<template>
    <div class="">
        
        <CCard class="mob-pd-0px">
            <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
                <CRow class="flex-flow-column">
                    <CCol v-if="!isBooking">
                        <strong>{{ $t("ticketingQueue.title") }}</strong>
                    </CCol>
                    <CCol v-if="isBooking">
                        <strong>{{ $t("mybookingPage.title") }}</strong>
                    </CCol>
                    <p class="desc" v-if="!isBooking">{{ ADMIN_SIGNIN_RES? $t("ticketingQueue.admindesc") :
                        $t("ticketingQueue.desc")}}</p>
                    <p class="desc" v-if="isBooking">{{ ADMIN_SIGNIN_RES? $t("mybookingPage.admindesc") :
                        $t("mybookingPage.desc") }}</p>

                </CRow>
                <div @click="toggleJsonExcelModal()" class="generate-ex-btn" v-if="ticketingQueueList.length>0">
                    <img src="@imgPath/img/svg/icons/excle-icon.svg" alt/>
                </div>
            </CCardHeader>
            <CCardBody class="user-manage-table pt-0px ticketing_queue_p">
                <CRow v-if="ticketingQueueList" class="tq-header-nav">
                    <CCol md="8">
                        <CRow>
                            <CCol class="d-flex align-center text-left mt-2" md="3" sm="6" xs="12">

                                <cTextInputComponent v-model="searchObj.orderId"
                                                     :placeholder="'Reservation ID'"
                                                     class="w-100"></cTextInputComponent>
                            </CCol>
                            <CCol class="d-flex align-center text-left mt-2" md="3" sm="6" xs="12">
                                <cTextInputComponent v-model="searchObj.pnr" :placeholder="'PNR'"
                                                     class="w-100"></cTextInputComponent>
                            </CCol>
                            <CCol class="d-flex align-center text-left  mt-2" md="3" sm="6" xs="12">
                                <cTextInputComponent v-model="searchObj.firstName"
                                                     :placeholder="'Eg. First Name'" class="w-100"></cTextInputComponent>
                            </CCol>
                            <CCol class="d-flex align-center text-left mt-2" md="3" sm="6" xs="12">
                                <cTextInputComponent v-model="searchObj.lastName"
                                                     :placeholder="'Eg. Last Name'" class="w-100"></cTextInputComponent>
                            </CCol>

                        </CRow>

                    </CCol>
                    <CCol md="4" class="d-flex align-center">
                        <div class="d-flex align-center w-100 action-btn-tq">
                            <div>
                                <CButton @click="onSearch()"
                                         class="btn-outline-success ml-0px">
                                    {{ $t("ticketingQueue.apply") }}
                                </CButton>
                                <!-- <CAlert v-if="filterAlert" show color="danger">{{ filterAlert }}</CAlert> -->
                            </div>
                            <div @click="isShowMoreFilter=!isShowMoreFilter"
                                 class="mr-10px more-btns" :class="{'rotate':isShowMoreFilter}">
                                <span>
                                   {{ $t("ticketingQueue.more") }} <div>{{ $t("ticketingQueue.filter") }}</div>
                                </span>
                                <!--                                <img src="@imgPath/img/svg/icons/more-menu.svg" alt=""     height="42px"  width="27px">-->
                            </div>
                            <!-- <div class="item-per-page ml-auto">
                                <div  class="form-inline justify-content-sm-end"><label
                                         class="mr-2">Items per page:</label><select
                                         class="form-control">
                                    <option  value="" selected="selected" disabled="disabled"
                                            hidden="hidden"> 10
                                    </option>
                                    <option  val="5"> 5</option>
                                    <option  val="10"> 10</option>
                                    <option  val="20"> 20</option>
                                    <option  val="50"> 50</option>
                                </select></div>
                            </div> -->


                            <!--                        <CButton @click="clearFilter()">Clear All Filter</CButton>-->


                        </div>

                    </CCol>
                    <CCol md="12" class=" multisele-max-40-h">
                        <CCollapse :show="isShowMoreFilter">
                            <CRow class="extra-filters">

                                <CCol md="12">
                                    <CRow>
                                        <CCol  md="4" sm="6"  class="d-flex">


                                            <multiselect
                                                    :allow-empty="false"
                                                    :showLabels="false"
                                                    :clearOnSelect="false"
                                                    v-model="search.departure"
                                                    :options="lsCountryRoute"
                                                    :multiple="false"
                                                    group-values="routeList"
                                                    group-label="country"
                                                    :group-select="false"
                                                    :placeholder="'Departure'"
                                                    track-by="depcode"
                                                    v-on:input="getDepartureRoute"
                                                    class="mt-auto"
                                                    ref="fromCityPicker"
                                                    :searchable="true"
                                                    :custom-label="cityPickCustomeLabel"
                                                    @search-change="addCssClass()"
                                            >
                                                <template
                                                        slot="singleLabel"
                                                        slot-scope="{ option }"
                                                >{{ option.depcode.city}} ({{option.depcode.airportcode}})</template>
                                                <template slot="option" slot-scope="props">
                                                    <div>
                                                        <span v-if="props.option.$isLabel">{{ props.option.$groupLabel.value }}</span>
                                                        <span v-else>
                      {{ props.option.depcode.city}}
                      <strong
                              v-if="props.option.depcode"
                              class="right"
                      >{{ props.option.depcode.airportcode }}</strong>
                    </span>
                                                    </div>
                                                </template>
                                                <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                                            </multiselect>
                                            <!-- <cTextInputComponent v-model="searchObj.departure"
                                                                 :placeholder="'Departure'"></cTextInputComponent> -->
                                        </CCol>
                                        <CCol md="4" sm="6" class="mt-2 d-flex mob-mt-25px">
                                            <multiselect
                                                    class="mt-auto"
                                                    :allow-empty="false"
                                                    :showLabels="false"
                                                    :clearOnSelect="false"
                                                    v-model="search.arrival"
                                                    :options="lsCountryRoute"
                                                    :multiple="false"
                                                    group-values="routeList"
                                                    group-label="country"
                                                    :group-select="false"
                                                    :placeholder="'Arrival'"
                                                    track-by="depcode"
                                                    v-on:input="getArrivalRoute"
                                                    ref="fromCityPicker"
                                                    :searchable="true"
                                                    :custom-label="cityPickCustomeLabel"
                                                    @search-change="addCssClass()"
                                            >
                                                <template
                                                        slot="singleLabel"
                                                        slot-scope="{ option }"
                                                >{{ option.depcode.city}} ({{option.depcode.airportcode}})</template>
                                                <template slot="option" slot-scope="props">
                                                    <div>
                                                        <span v-if="props.option.$isLabel">{{ props.option.$groupLabel.value }}</span>
                                                        <span v-else>
                                             {{ props.option.depcode.city}}
                      <strong
                              v-if="props.option.depcode"
                              class="right"
                      >{{ props.option.depcode.airportcode }}</strong>
                    </span>
                                                    </div>
                                                </template>
                                                <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                                            </multiselect>

                                            <!-- <cTextInputComponent v-model="searchObj.arrival"
                                                                 :placeholder="'Arrival'"></cTextInputComponent> -->
                                        </CCol>
                                        <CCol md="2" sm="6" class="mt-2 " v-if="isBooking">
                                            <cTextInputComponent v-model="searchObj.ticketNumber"
                                                                 :placeholder="'Ticket Number'"></cTextInputComponent>
                                        </CCol>
                                        <!-- <CCol md="2" sm="6" class="mt-2" v-if="isBooking">
                                          <cTextInputComponent v-model="searchObj.arrival"
                                                               :placeholder="'Contact Number'" label="Contact Number"></cTextInputComponent>
                                        </CCol> -->
                                        <CCol md="2" sm="6" class="mt-2 journey-type">
                                            <label></label>
                                            <multiselect
                                                    v-model="filterOption.selectedJType"
                                                    :options="jTypeFilterOption"
                                                    :disabled="false"
                                                    :isMultiple="false"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    :placeholder="'Journey Type'"
                                                    @input="onChangeJType"
                                                    deselectLabel
                                                    deselectGroupLabel
                                                    selectLabel
                                                    selectedLabel
                                            >
                                                <template slot="singleLabel" slot-scope="props">
                                                    {{ props.option
                                                    }}
                                                </template>
                                                <template slot="option" slot-scope="props">
                                                    <div>
                                                        <span>{{ props.option}}</span>
                                                    </div>
                                                </template>
                                                <template #noResult>
                                                    <strong>
                                                        {{$t('manageAgent.resultEmpty')}}
                                                    </strong>
                                                </template>
                                                <template #noOptions>
                                                    <strong>
                                                        {{$t('manageAgent.optionEmpty')}}
                                                    </strong>
                                                </template>
                                            </multiselect>
                                        </CCol>
                                        <CCol md="2" sm="6" class="mt-2 airline d-flex">
                                            <cAirLine
                                                    class="mt-auto w-100"
                                                    v-model="filterOption.selectedAirline"
                                                    ctrlName="airline_name"
                                                    ctrlCode="airline_code"
                                                    :isShowCode="true"
                                                    :isMultiple="false"
                                                    :isSearchable="true"
                                                    :placeholder="'Airline'"
                                                    :selValue="filterOption.selectedAirline"
                                                    @input="onChangeAirline"
                                                    :isShowDefaultAirline="false"

                                            />
                                        </CCol>
                                        <CCol md="2 " sm="6" class="mt-2 d-flex" v-if="AGENT_SIGNIN_RES">
                                            <multiselect
                                                    v-if="filterOption.user"
                                                    v-model="filterOption.selectedUser"

                                                    :options="filterOption.user"
                                                    :disabled="false"
                                                    :isMultiple="false"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    :placeholder="'User'"
                                                    @input="onChangeUser"
                                                    deselectLabel
                                                    deselectGroupLabel
                                                    selectLabel
                                                    selectedLabel
                                                    class="mt-auto"

                                            >
                                                <template slot="singleLabel" slot-scope="props">
                                                    {{ props.option.firstname + ' ' + props.option.lastname
                                                    }}
                                                </template>
                                                <template slot="option" slot-scope="props">
                                                    <div>
                                                        <span>{{ props.option.firstname + ' ' + props.option.lastname}}</span>
                                                    </div>
                                                </template>
                                                <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                                            </multiselect>
                                        </CCol>
                                        <CCol md="4" sm="6" v-if="ADMIN_SIGNIN_RES"
                                              class="select_agent mt-2 dropdown-center-align">

                                            <cAgent
                                                    v-model="filterOption.agency"
                                                    :ctrlName="'agencyname'"
                                                    :ctrlCode="'b2bid'"
                                                    :isShowCode="true"
                                                    :isSearchable="true"
                                                    @input="onChangeAgent"
                                                    :isMultiple="true"
                                                    :isAll="true"
                                                    :agentType="'null'"
                                                    :toShowAgencyGroup="true"
                                            />
                                        </CCol>
                                        <CCol md="4" class="tq-date-picker mt-2">
                                            <!-- z-index-99999999 -->
                                            <div class="ext-date-wrapper">


                                                <label>{{ $t("ticketingQueue.trvlDate") }}</label>
                                                
                                            <div class="ext-date-wrapper">
                                               
                                                <v-md-date-range-picker
                                                        :start-date="searchObj.travelDateFrom?searchObj.travelDateFrom.toString():new Date().toString()"
                                                        :end-date="searchObj.travelDateTo?searchObj.travelDateTo.toString(): new Date().toString()"
                                                        :autoApply="true"
                                                        :showYearSelect="true"
                                                        :maxYear="getMaxYear(true)"
                                                        :minYear="getMinYear()"
                                                        @change="onChangeTravelDate"
                                                       
                                                >
                                                    <template slot="input">
                                                        <datePickerInput  @click.native="onToggleTravelDatePicker" :fromDate="searchObj.travelDateFrom?searchObj.travelDateFrom:null" :toDate="searchObj.travelDateTo?searchObj.travelDateTo:null" :fromLabel="$t('ticketingQueue.fromDateLabel')" :toLabel="$t('ticketingQueue.toDateLabel')"/>
                                                    </template>
                                                </v-md-date-range-picker>
                                            </div>
                                            <!-- <div  @click="getStartingDate()"> -->
                                            <!-- <datePicker @click.native="getStartingDate" v-if="isSdate"

                                             :startDate="new Date(null)"
                                            :startingDateValue="sdate"
                                             :enableCheckin="true"
                                             format="DD-MMM-YYYY"
                                             @check-in-changed="getTravelDate($event,true)"
                                             @check-out-changed="getTravelDate($event,false)"
                                             :displayClearButton="false"
                                             :hoveringTooltip="false"
                                             ref="travelDatePicker"
                                             :i18n="assigni18nObjByLang()"
                                             :showYear="true"

                                           /> -->
                                            </div>
                                        </CCol>
                                        <CCol md="4" class="tq-date-picker mt-2">
                                            <!-- z-index-9999999 -->
                                            <div class="ext-date-wrapper left">


                                                <label>{{ $t("mybookingPage.bookDate") }}</label>
                                                <!-- :startingDateValue="searchObj.bookingDateFrom?new Date(searchObj.bookingDateFrom):null" -->
                                                <!-- :endingDateValue="searchObj.bookingDateTo?new Date(searchObj.bookingDateTo): null" -->
                                                <!-- :startDate="new Date(null)" -->
                                                <!--                                            <label class="date-label" :class="{'show' : (searchObj.bookingDateFrom == null || searchObj.bookingDateTo == null) ? true : false}" >-->
                                                <!--                                -->
                                                <!--                                                   <div v-if="searchObj.bookingDateFrom == null" class="form">{{ "From Date"}}-->
                                                <!--                                                   </div>-->
                                                <!--                                                   <div v-if="searchObj.bookingDateTo == null" class="to">{{ "To Date"}}-->
                                                <!--                                                   </div>-->
                                                <!--                                          </label >-->
                                                <!-- <HotelDatePicker
                                                        :startingDateValue="searchObj.bookingDateFrom?new Date(searchObj.bookingDateFrom):new Date()"
                                                        :endingDateValue="searchObj.bookingDateTo?new Date(searchObj.bookingDateTo): new Date()"
                                                        :startDate="new Date(null)"
                                                        format="DD-MMM-YYYY"
                                                        @check-in-changed="getBookingDate($event,true)"
                                                        @check-out-changed="getBookingDate($event,false)"
                                                        :displayClearButton="false"
                                                        :hoveringTooltip="false"
                                                        ref="bookingDatePicker"
                                                        :i18n="assigni18nObjByLang()"
                                                        :showYear="true"
                                                        :minNights="0"

                                                        :class="{'show' : (searchObj.bookingDateFrom == null && searchObj.bookingDateTo == null) ? true : false}"

                                                /> -->
                                                <v-md-date-range-picker
                                                        :start-date="searchObj.bookingDateFrom?searchObj.bookingDateFrom.toString():new Date().toString()"
                                                        :end-date="searchObj.bookingDateTo?searchObj.bookingDateTo.toString(): new Date().toString()"
                                                        :autoApply="true"
                                                        :showYearSelect="true"
                                                        :maxYear="getMaxYear()"
                                                        :minYear="getMinYear()"
                                                        @change="onChangeBookingDate"
                                                         
                                                >
                                                    <template slot="input">
                                                        <datePickerInput  @click.native="onToggleBookingDatePicker" :fromDate="searchObj.bookingDateFrom?searchObj.bookingDateFrom:null" :toDate="searchObj.bookingDateTo?searchObj.bookingDateTo:null" :fromLabel="$t('ticketingQueue.fromDateLabel')" :toLabel="$t('ticketingQueue.toDateLabel')"/>
                                                    </template>
                                                </v-md-date-range-picker>
                                            </div>
                                        </CCol>
                                        <CCol md="2" class="filter-wrap-tq">
                                            <div class="clear-filter-btn" @click="clearFilter()">
                                                <div>
                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                         xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                                                         id="Layer_1" x="0px" y="0px" viewBox="0 0 492 492"
                                                         style="fill: rgb(30, 144, 255); enable-background:new 0 0 492 492;"
                                                         xml:space="preserve">
<g>
	<g>
		<path d="M300.188,246L484.14,62.04c5.06-5.064,7.852-11.82,7.86-19.024c0-7.208-2.792-13.972-7.86-19.028L468.02,7.872    c-5.068-5.076-11.824-7.856-19.036-7.856c-7.2,0-13.956,2.78-19.024,7.856L246.008,191.82L62.048,7.872    c-5.06-5.076-11.82-7.856-19.028-7.856c-7.2,0-13.96,2.78-19.02,7.856L7.872,23.988c-10.496,10.496-10.496,27.568,0,38.052    L191.828,246L7.872,429.952c-5.064,5.072-7.852,11.828-7.852,19.032c0,7.204,2.788,13.96,7.852,19.028l16.124,16.116    c5.06,5.072,11.824,7.856,19.02,7.856c7.208,0,13.968-2.784,19.028-7.856l183.96-183.952l183.952,183.952    c5.068,5.072,11.824,7.856,19.024,7.856h0.008c7.204,0,13.96-2.784,19.028-7.856l16.12-16.116    c5.06-5.064,7.852-11.824,7.852-19.028c0-7.204-2.792-13.96-7.852-19.028L300.188,246z"/>
	</g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
</svg>

                                                    {{$t('ticketingQueue.clearAll')}}
                                                </div>

                                            </div>

                                        </CCol>

                                    </CRow>


                                </CCol>
                             

                            </CRow>

                        </CCollapse>
                    </CCol>


                </CRow>

                    <!-- <template #fullScreen> -->

                        <CRow  :class="[{'fullscreen-ex-row':true},{'table_count_visible': statusCount || orderStatusCount}]">

                            <CCol>
                                <!-- @update:sorter-value="sortList" -->

                                <cTable                                            
                                        :items="tQComputedList"
                                        :fields="tickQueueFields"
                                        caption="TicketingQueue"
                                        items-per-page-select
                                        :items-per-page="cTicketingTableWatchList.itemsPerPage"
                                        hover
                                        :sorter='{  resetable: true }'
                                        :class="{agent_table:AGENT_SIGNIN_RES} + ' mt-0'"
                                        pagination
                                        :loading="isLoading"
                                        class="usersTable border-grey manage-user-table table table-striped table-hover"
                                        id="user-manage-table"
                                        @row-clicked="getTicketingOrderDetails"
                                        @filtered-items-change="getFilteredAgentCount"
                                        @page-change="onPageChange"
                                        @pagination-change="onPaginationChange"
                                        :sorterValue="{ column:isBooking?'orderId':'ticketingdeadline', asc:isBooking?false:true }"
  @getFields="onSaveColumns"
                                    :tableWatchList="cTicketingTableWatchList"
                                    :manageColumn="true"
                                    :paginationLenOption="true"
                                    :activePage="cTicketingTableWatchList.currentPageNum"

                                >
                                    <template #sub-over-table>
<!--
                                        <cPaginationLenOption :paginationWatchLs="cTicketingTableWatchList"/>

                                           <cManageColumns v-if="tickQueueFields&&tickQueueFields.length>0" :lsFields="tickQueueFields" @getFields="onSaveColumns"/> -->

                                           <div class="table-count-wrap" v-if="statusCount">
                                               <div class="row">
                                                   <div class="pd-wrap" v-if="statusCount[15]">
                                                       <div class="tc-inactive-wrap"><span> {{ $t("ticketingQueue.cancelled") }}  </span> <span>
                                           {{statusCount[15]}}</span></div>
                                                   </div>
                                                   <div class="pd-wrap" v-if="statusCount[10]">
                                                       <div class="tc-active-wrap "><span>{{ $t("ticketingQueue.ticketed") }}  </span> <span>
                                           {{statusCount[10]}}</span></div>
                                                   </div>
                                                   <div class="pd-wrap" v-if="statusCount[11]">
                                                       <div class="tc-inactive-wrap"><span>{{ $t("ticketingQueue.failed") }}  </span> <span>{{statusCount[11]}}</span></div>
                                                   </div>
                                                   <div class="pd-wrap" v-if="statusCount[8]">
                                                       <div class="tc-inactive-wrap pending"><span>{{ $t("ticketingQueue.pending") }}  </span> <span>{{statusCount[8]}}</span></div>
                                                   </div>
                                                   <div class="pd-wrap" v-if="statusCount[7]">
                                                       <div class="tc-inactive-wrap hold"><span>{{ $t("ticketingQueue.hold") }}  </span> <span>{{statusCount[7]}}</span></div>
                                                   </div>
                                               </div>
                                           </div>
                                           <div class="table-count-wrap" v-else-if="orderStatusCount">
                                               <div class="row">
                                                   <div class="pd-wrap" v-if="orderStatusCount[15]">
                                                       <div class="tc-inactive-wrap"><span> {{ $t("ticketingQueue.cancelled") }}  </span> <span>
                                           {{orderStatusCount[15]}}</span></div>
                                                   </div>
                                                   <div class="pd-wrap" v-if="orderStatusCount[10]">
                                                       <div class="tc-active-wrap"><span>{{ $t("ticketingQueue.ticketed") }}   </span> <span>
                                           {{orderStatusCount[10]}}</span></div>
                                                   </div>
                                                   <div class="pd-wrap" v-if="orderStatusCount[11]">
                                                       <div class="tc-inactive-wrap"><span>{{ $t("ticketingQueue.failed") }}   </span> <span>{{orderStatusCount[11]}}</span></div>
                                                   </div>
                                                   <div class="pd-wrap" v-if="orderStatusCount[8]">
                                                       <div class="tc-inactive-wrap pending"><span>{{ $t("ticketingQueue.pending") }}  </span> <span>{{orderStatusCount[8]}}</span></div>
                                                   </div>
                                                   <div class="pd-wrap" v-if="orderStatusCount[7]">
                                                       <div class="tc-inactive-wrap hold"><span>{{ $t("ticketingQueue.hold") }}  </span> <span>{{orderStatusCount[7]}}</span></div>
                                                   </div>
                                               </div>
                                           </div>


                                        <!-- <img src="@imgPath/img/svg/icons/small_screen.svg" alt="" v-if="fullscreen" @click="toggle" class="fullscreen-btn">
                                        <img src="@imgPath/img/svg/icons/full_screen.svg" alt="" v-if="!fullscreen" @click="toggle" class="fullscreen-btn"> -->

                                        <!--                            <button type="button" @click="toggle" >{{fullscreen?'Exit Fullscreen':'Fullscreen'}}</button>-->
                                    </template>
                                    <template #no-items-view>
                                        <div class="text-center my-5">
                                            <h3>{{ isLoading?'':isFiltersApplied?$t("ticketingQueue.filterAppliedlistEmpty"):$t("ticketingQueue.listEmpty") }}</h3>
                                        </div>
                                    </template>
                                    <!-- <template #bookingDate="{item}">
                                        <td class="py-2">
                                            <div v-if="item.orderId"><strong>{{ item.orderId }}</strong></div>
                                            <div
                                                    v-if="item.bookingDate"
                                            >
                                                {{item.bookingDate | formatDateTime(DATE_TIME_FORMAT.DATE_TIME_MINS) }}
                                            </div>
                                        </td>
                                    </template> -->
                                    <template #orderId-header class="tes">
                                        <div class="d-flex white-space-unset-div">
                                     <span class="white-space-pre">
                                         {{$t('ticketingQueue.reservationId')}}
                                     </span>
                                            <cHelpTip class="right" :content="$t('helpTip.ticketingQue_resId')"></cHelpTip>
                                        </div>
                                    </template>
                                    <template #orderId="{item}">
                                        <td class="py-2">
                                            <div v-if="item.orderId"><strong>{{ item.orderId }}</strong></div>
                                            <div
                                                    v-if="item.bookingDate"
                                            >
                                                {{item.bookingDate | formatDateTime(DATE_TIME_FORMAT.DATE_TIME_MINS) }}
                                            </div>
                                        </td>
                                    </template>
                                    <template #passengername="{item}">
                                        <td class="py-2 passengerName_tb" >
                                            <div v-if="item.passengername"><strong>{{ item.passengername }}</strong></div>
                                            <div>{{ getPassengerCount(item) }}
                                            </div>
                                            <!-- <div v-else>{{ " - " }}</div> -->
                                        </td>
                                    </template>
                                    <template #contactmail="{item}">
                                        <td class="py-2">
                                            <div v-if="item.contactnumber"><strong>{{ item.contactnumber }}</strong></div>
                                            <div v-if="item.contactmail">{{ item.contactmail}}
                                            </div>
                                            <!-- <div v-else>{{ " - " }}</div> -->
                                        </td>
                                    </template>

                                    <template #journeytype="{item}">
                                        <td class="py-2">
                                            <div v-if="item.FlightDetails">
                                                <div v-if="item.journeytype== journeyType.oneWay||item.journeytype== journeyType.roundTrip">
                                                    <div>
                                                        <div v-if="item.FlightDetails[0].departure && item.FlightDetails[0].arrival">
                                                            <strong class="c-lit-black">{{item.FlightDetails[0].departure + ' - ' +
                                                                item.FlightDetails[0].arrival}}</strong>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div v-else-if="item.journeytype== journeyType.multiCity">
                                                    <div v-for="(flight,index) in item.FlightDetails" :key="index">
                                                        <div v-if="flight.departure && flight.arrival">
                                                            <strong class="c-lit-black">{{flight.departure + ' - ' +
                                                                flight.arrival}}</strong>
                                                        </div>
                                                    </div>

                                                </div>
                                                <!-- <div v-if="item.FlightDetails.length == journeyType.oneWay">
                                                    <div v-if="item.FlightDetails[0].departure && item.FlightDetails[0].arrival">
                                                        <strong>{{item.FlightDetails[0].departure + ' - ' +
                                                            item.FlightDetails[0].arrival}}</strong>
                                                    </div>
                                                </div>
                                                <div v-else-if="item.FlightDetails.length > journeyType.oneWay">
                                                    <div v-if="item.FlightDetails[0].departure && item.FlightDetails[item.FlightDetails.length-1].departure">
                                                        <strong>{{item.FlightDetails[0].departure + ' - ' +
                                                            item.FlightDetails[item.FlightDetails.length-1].departure}}</strong>
                                                    </div>
                                                </div> -->
                                                <div>
                                                    <div
                                                            v-if="item.journeytype == journeyType.oneWay"
                                                    >{{ $t('ticketingQueue.oneWay')}}
                                                    </div>
                                                    <div
                                                            v-else-if="item.journeytype == journeyType.roundTrip"
                                                    >{{ $t('ticketingQueue.roundTrip') }}
                                                    </div>
                                                    <div
                                                            v-else-if="item.journeytype == journeyType.multiCity"
                                                    >{{ $t('ticketingQueue.multiCity') }}
                                                    </div>
                                                    <div v-else>{{ " - " }}</div>
                                                </div>

                                                <!-- </div> -->
                                            </div>
                                        </td>
                                    </template>

                                    <template #flight_number="{item}">
                                        <td class="py-2 div-2-color-unset">
                                            <div v-if="item.FlightDetails">
                                                <div v-for="(flight,index) in item.FlightDetails" :key="'f'+index">
                                                    <!-- <div v-if="flight.flight_number">{{flight.flight_number}}</div> -->
                                                    <div v-if="flight.flight_number">
                                                        <div  v-for="(flightNum,index) in flight.flight_number.split(',')"
                                                              :key="'t'+index">
                                                            {{flightNum}}
                                                        </div>
                                                    </div>
                                                    <div v-else>{{ " - " }}</div>
                                                </div>
                                            </div>
                                        </td>
                                    </template>

                                    <template #departuredate="{item}">
                                        <td class="py-2 div-2-color-unset">
                                            <div v-if="item.FlightDetails">
                                                <div v-if="item.journeytype == journeyType.roundTrip&&item.FlightDetails.length==1">
                                                    <div
                                                            v-if="item.FlightDetails[0].departuredate"
                                                    >{{item.FlightDetails[0].departuredate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                                    </div>
                                                    <div
                                                            v-if="item.FlightDetails[0].returndate"
                                                    >{{item.FlightDetails[0].returndate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                                    </div>
                                                </div>
                                                <!-- <div v-else-if="item.journeytype == journeyType.oneWay">
                                                    <div
                                                            v-if="item.FlightDetails[0].departuredate"
                                                    >{{item.FlightDetails[0].departuredate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                                    </div>

                                                </div> -->
                                                <div v-else>
                                                    <div v-for="(flight,index) in item.FlightDetails" :key="index"

                                                    >{{flight.departuredate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                                    </div>

                                                </div>


                                                <!-- <div v-if="item.FlightDetails.length == journeyType.oneWay">
                                                    <div
                                                            v-if="item.FlightDetails[0].departuredate"
                                                    >{{item.FlightDetails[0].departuredate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                                    </div>
                                                    <div
                                                            v-if="item.FlightDetails[0].returndate"
                                                    >{{item.FlightDetails[0].returndate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                                    </div>
                                                </div>
                                                <div v-else-if="item.FlightDetails.length > journeyType.oneWay">
                                                    <div
                                                            v-if="item.FlightDetails[0].departuredate"
                                                    >{{item.FlightDetails[0].departuredate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                                    </div>
                                                    <div
                                                            v-if="item.FlightDetails[item.FlightDetails.length-1] && item.FlightDetails[item.FlightDetails.length-1].departuredate"
                                                    >{{item.FlightDetails[item.FlightDetails.length-1].departuredate |
                                                        formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                                    </div>
                                                </div> -->
                                            </div>
                                        </td>
                                    </template>
                                    <template #pnr="{item}">
                                        <td class="py-2 pnr-number">
                                            <div v-if="item.FlightDetails">
                                                <div v-for="(flight,index) in item.FlightDetails" :key="'f'+index">
                                                    <div v-if="flight.pnr">{{flight.pnr}}</div>
                                                    <div v-else>{{ " - " }}</div>
                                                </div>
                                            </div>
                                        </td>
                                    </template>
                                    <template #username="{item}">
                                        <td class="py-2  ">
                                            <div v-if="item.agencyname"><strong>{{ item.agencyname }}</strong></div>
                                            <div v-if="item.username">{{ item.username}}
                                            </div>
                                        </td>
                                    </template>
                                    <template #agencyname="{item}">
                                        <td class="py-2  ">
                                            <div v-if="item.agencyname"><strong>{{ item.agencyname }}</strong></div>
                                            <div v-if="item.username">{{ item.username}}
                                            </div>


                                        </td>
                                    </template>
                                    <template #amount="{item}">
                                        <!--                                d-flex align-center amount-->
                                        <td class="py-2 ">
                                            <div class="d-flex align-center amount">
                                                <div v-if="item.currency"><strong class="mr-10px">{{ item.currency }}</strong></div>
                                                <div v-if="item.amount">{{ item.amount | formatNumber(item.currency)}}
                                                </div>

                                            </div>
                                        </td>
                                    </template>
                                    <template #ticketingdeadline="{item}">
                                        <td class="py-2 ticketing-deadline ">

                                            <div v-if="checkStatus(item,isBooking)">
                                                <div
                                                        v-if="item.ticketingdeadline"
                                                >{{item.ticketingdeadline | formatDateTimeTZ(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                                </div>
                                                <div
                                                        v-if="item.ticketingdeadline"
                                                >{{item.ticketingdeadline |timeLeftFormat}}
                                                </div>
                                            </div>
                                            <div v-else>{{ " - " }}</div>


                                            <div class="">




                                            </div>

                                        </td>
                                    </template>
                                    <!-- <div v-if="AGENT_SIGNIN_RES"> -->
                                    <template #actions="{item}">








                                <td  class="py-2 filled-icon-wrap">


                                      <div class="d-flex"  v-if="isBooking &&AGENT_SIGNIN_RES&& getExchangeStatus(item)">
                                        <div class="filled-icon-btn r-payment">
                                               <img src="@imgPath/img/svg/icons/exchange-arrow.svg" alt="" @click.stop="navToExchange(item)" v-c-tooltip.hover="{ content:$t('ticketingQueue.exchange') , active:false }">
<!--                                            <span>{{$t('ticketingQueue.exchange')}}</span>-->
                                        </div>

                                    </div>  

                                            <div class="d-flex"  v-if="isBooking &&AGENT_SIGNIN_RES&&  getRefundStatus(item)">
                                                <div class="filled-icon-btn r-payment">
                                                    <img src="@imgPath/img/svg/icons/retry-npay.svg" alt="" @click.stop="navToRefund(item)" v-c-tooltip.hover="{ content:$t('ticketingQueue.refund') , active:false }">
<!--                                                    <span>{{$t('ticketingQueue.refund')}}</span>-->
                                                </div>

                                            </div>
                                       

                                            <div class="d-flex"  v-if="getRetryBtnStatus(item)&&!isBooking&&AGENT_SIGNIN_RES || checkHoldByOrderStatus(item)&&!isBooking&&AGENT_SIGNIN_RES || getCancelBtnStatus(item)&&AGENT_SIGNIN_RES">

                                                <div v-if="getRetryBtnStatus(item)&&!isBooking&&AGENT_SIGNIN_RES" class="filled-icon-btn r-payment" @click.stop="onShowRetryPayModel(item)">
                                                    <img src="@imgPath/img/svg/icons/retry-npay.svg" alt="" v-c-tooltip.hover="{ content:$t('ticketingQueue.retryPayment') , active:false }">
<!--                                                    <span>{{$t('ticketingQueue.retryPayment')}}</span>-->
                                                </div>

                                                <div v-if="checkHoldByOrderStatus(item)&&!isBooking&&AGENT_SIGNIN_RES" class="filled-icon-btn t-now" @click.stop="emitNav(item)">
                                                    <img src="@imgPath/img/svg/icons/filled-ticket-now.svg" alt="" v-c-tooltip.hover="{ content:$t('ticketingQueue.tcktNow') , active:false }">
<!--                                                    <span>{{$t('ticketingQueue.tcktNow')}}</span>-->
                                                </div>
                                                <div v-if="getCancelBtnStatus(item)&&AGENT_SIGNIN_RES" class="filled-icon-btn cancel"  @click.stop="onShowCancelConfirmation(item)">
                                                    <img src="@imgPath/img/svg/icons/filled-cancel.svg" alt="" v-c-tooltip.hover="{ content:$t('ticketingQueue.cancel') , active:false }">
                                                    <!-- <span>
                                               {{$t('ticketingQueue.cancel')}}
                                            </span> -->
                                                </div>









                                                <!-- <div v-if="getRetryBtnStatus(item)&&!isBooking&&AGENT_SIGNIN_RES" class="filled-icon-btn download" @click.stop="onShowRetryPayModel(item)">
                                                    <button>Retry Payment</button>
                                                </div>
                                                <div v-if="checkHoldByOrderStatus(item)&&!isBooking&&AGENT_SIGNIN_RES" class="filled-icon-btn download" @click="emitNav(item)">
                                                    <img src="@imgPath/img/svg/icons/filled-dowload.svg" alt="">
                                                </div>
                                                <div v-if="getCancelBtnStatus(item)&&AGENT_SIGNIN_RES" class="filled-icon-btn cancel"  @click.stop="onShowCancelConfirmation(item)">
                                                    <img src="@imgPath/img/svg/icons/filled-cancel.svg" alt="">
                                                    <span>
                                                        Cancel
                                                    </span>
                                                </div> -->
                                                <!--                                         <CButton @click="emitNav(item)"-->
                                                <!--                                                 class="btn align-right btn-lit-blue btn-success m-10px text-center">-->
                                                <!--                <span>-->
                                                <!--                        {{ $t('ticketingQueue.tcktNow') }}-->
                                                <!--                </span>-->
                                                <!--                                        </CButton>-->
                                                <!--                                        <CButton @click.stop="onShowCancelConfirmation(item)"-->
                                                <!--                                                 class="btn align-right btn-lit-blue btn-success m-10px bg-danger text-center">-->
                                                <!--                <span>-->
                                                <!--                        {{ $t('ticketingQueue.cancelBtn') }}-->
                                                <!--                </span>-->
                                                <!--                                        </CButton>-->
                                                <!-- <div @click="emitAlertModal(item.orderId)" class="m-10px">
                                                    <CIcon style="color: #cd0606;" name="cil-trash" size="lg"></CIcon>
                                                </div>
                                                <CIcon style name="cil-clone" size="lg" class="m-10px"></CIcon> -->
                                            </div>
                                            <div class="d-flex">
                                                <div class="filled-icon-btn r-payment">
                                                    <img src="@imgPath/img/svg/icons/view.svg" alt="" v-c-tooltip.hover="{ content:$t('ticketingQueue.view') , active:false }">
<!--                                                    <span>{{$t('ticketingQueue.view')}}</span>-->
                                                </div>

                                            </div>
                                            <div v-if="checkHoldByOrderStatus(item)&&!isBooking&&ADMIN_SIGNIN_RES" class="filled-icon-btn t-now" @click.stop="emitNav(item)" >
                                                    <img src="@imgPath/img/svg/icons/filled-ticket-now.svg" alt=""  v-c-tooltip.hover="{ content:$t('ticketingQueue.tcktNow') , active:false }">
<!--                                                    <span>{{$t('ticketingQueue.tcktNow')}}</span>-->
                                                </div>
                                        </td>




                                    </template>
                                    <!-- <template #action="{item}">
                                  <td class="py-2">
                                    <CRow v-if="isBooking">
                                      <CButton v-if="item.">{{ $t('ticketingQueue.tcktNow') }}</CButton>
                                      <div>
                                        <CIcon style="color: #cd0606;" name="cil-trash" size="lg"></CIcon>
                                      </div>
                                      <CIcon style name="cil-clone" size="lg"></CIcon>
                                    </CRow>
                                  </td>
                                    </template>-->
                                    <template #ticketnumbers="{item}">
                                        <td class="py-2">
                                            <div v-if="item.FlightDetails" :class="{'limit-ticket-no':item.FlightDetails && item.FlightDetails[0] && item.FlightDetails[0].ticketnumbers&&item.FlightDetails[0].ticketnumbers.split(',').length>3}">
                                                <div v-for="(flight,index) in item.FlightDetails" :key="'f'+index" >
                                                    <div v-if="flight.ticketnumbers">
                                                        <div v-for="(ticket,index) in flight.ticketnumbers.split(',')"
                                                             :key="'t'+index">
                                                            {{ticket}}
                                                        </div>
                                                    </div>
                                                    <div v-else>{{ " - " }}</div>
                                                </div>
                                            </div>
                                        </td>
                                    </template>
                                    <template #bookingStatus="{item}">
                                        <td class="py-2 ">
                                            <div class="t-body">
                                                <div class="content-wrap">
                                                    <div class="t-wrap">
                                                        <div :class="'indicate-dot'+ ' '+ getStatusClass(item)">
                                                            <div></div>

                                                        </div>
                                                       


                                             <span :class="'indicate-dot-text ' +' '+getStatusClass(item)" v-if="item.orderType==BOOKING_ORDER_TYPE.REFUND">
                  
                                               {{refundBookingDet[item.status]}}
                                             </span>


                                             <span :class="'indicate-dot-text ' +' '+getStatusClass(item)"  v-else-if="item.orderType==BOOKING_ORDER_TYPE.EXCHANGE">
                                                        {{exchangeBookingDet[item.status]}}
                                             </span>


                                                   


                                                        <span v-else :class="'indicate-dot-text ' +' '+getStatusClass(item)">
                            <span v-if=" getStatusClass(item) == 'paid'">{{$t('ticketingQueue.ticketedSuccess')}}</span>
                            <span v-if=" getStatusClass(item) == 'unpaid'&&item.status==11">{{$t('ticketingQueue.ticketingPending')}}</span>
                           <span v-if=" getStatusClass(item) == 'partial_paid'">{{$t('ticketingQueue.hold')}}</span>
                      <span v-if=" getStatusClass(item) == 'unpaid'&&item.status==15">{{$t('ticketingQueue.bookingCancelled')}}</span>
                      <span v-if=" getStatusClass(item) == 'unpaid'&&item.status==8">{{$t('ticketingQueue.paymentStatusPending')}}</span>


                       </span>
                                                       
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </template>


                                    <!-- </div> -->
                                </cTable>
                            </CCol>
                        </CRow>
                        <!-- </fullscreen> -->
                    <!-- </template>
                </cFullScreen> -->

                <!-- Datatable End -->


            </CCardBody>
        </CCard>
      

        <div v-if="jsonData">
            <cJsonExcelModal
                    v-if="showJsonExcelModal"
                    :show="showJsonExcelModal"
                    :desc="$t('jsonExcelModal.desc', { name: isBooking ? $t('mybookingPage.title') : $t('ticketingQueue.title')})"
                    :onCancel="toggleJsonExcelModal"
            >
                <template #jsonExcel>
                    <div v-if="isBooking" @click="toggleJsonExcelModal()">
                        <cExportExcel
                                :data="jsonData"
                                :fields="jsonFields"
                                worksheet="MyBookings"
                                :name="getExcelFileName($t('mybookingPage.title'))"
                        > {{ $t("jsonExcelModal.download") }}
                        </cExportExcel>
                    </div>
                    <div v-if="!isBooking" @click="toggleJsonExcelModal()">
                        <cExportExcel
                                :data="jsonData"
                                :fields="jsonFields"
                                worksheet="TicketingQueue"
                                :name="getExcelFileName($t('ticketingQueue.title'))"
                        >{{ $t("jsonExcelModal.download") }}
                        </cExportExcel>
                    </div>
                </template>
            </cJsonExcelModal>
        </div>
        <CAlert v-if="alertValue" show color="danger">
            <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                    {{value}}
                </p>
            </div>
            <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
            </div>
            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                    {{alertValue}}
                </p>
            </div>
        </CAlert>
        <div class="order-detail">
            <!-- <cTicketingDetail v-if="isShowTicketingDetail" :ticketingDetail="ticketingOrderDetail"
            @close="toggleShowTicketingDetail" @navFromDetail="emitNav" :isBooking="isBooking"/> -->
        </div>
        <cAlertModal v-if="isShowCancelAlert"
                     :buttonList="[{
              name:$t('ticketingQueue.noBtn'),func:onRejectCancel,color:'danger'},
                {name:$t('ticketingQueue.yesBtn'),func:onCancelBooking,color:'success'},]"
                     :status="2"
                     :show="isShowCancelAlert"
                     :desc="$t('ticketingQueue.cancelConfirmation')"

        ></cAlertModal>

        <cAlertModal v-if="isBookCancelledAlert"
                     :buttonList="[
                {name:$t('ticketingQueue.okBtn'),func:onHideCancelledAlert,color:'success'},]"
                     :status="1"
                     :show="isBookCancelledAlert"
                     :desc="[$t('ticketingQueue.cancelBookingSuccessdesc'),
            selBookingDetail.orderid?$t('ticketingQueue.reservationId')+': '+selBookingDetail.orderid:''
            ]"


        ></cAlertModal>



        <cAlertModal v-if="isRetryPaymentAlert"
                     :buttonList="[{
              name:$t('ticketingQueue.noBtn'),func:onRejectCancel,color:'danger'},
                {name:$t('ticketingQueue.yesBtn'),func:onRetryPayment,color:'success'},]"
                     :status="2"
                     :show="isRetryPaymentAlert"
                     :desc="[$t('ticketingQueue.retryPaymentModalDesc1'),$t('ticketingQueue.retryPaymentModalDesc2')]"

        ></cAlertModal>
        <!-- <cAlertModal v-if="isBookCancelFailed"
         :buttonList="[
             {name:$t('ticketingQueue.okBtn'),func:onHideBookCancelFailed,color:'danger'},]"
        :status="0"
         :show="isBookCancelFailed"



       ></cAlertModal> -->
        <!-- :desc=[$t('ticketingQueue.cancelBookingSuccessdesc'),
        selBookingDetail.orderid?$t('ticketingQueue.reservationId')+': '+selBookingDetail.orderid:''] -->

    </div>
</template>
<script>

    import {
        COMPONENT_NAME,
        PATHNAME,
        TRIP,
        DEFAULT_DROPDOWN_STATUS,
        ALERT_MODAL_STATUS,DATE_TIME_FORMAT,
        BOOKING_STATUS,ORDER,BOOKING_ORDER_TYPE
    } from "../../util/constants";
    import BaseConfiguration from "../../config/base";
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../config/API_DATA";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "../../util/apiValidate";
    import {
        handleJWT,
        getErrorAlertValue,
        cloneData,
        removeDuplicates,
        OrderByList,GroupByList,cloneDeep, addClassToBody
    } from "../../util/util";
    import Logger from "../../services/logger";
    import {mapGetters, mapActions} from "vuex";
    import Multiselect from "vue-multiselect";
    import cAlertModal from "../../components/form/cAlertModal";
    import HotelDatePicker from "vue-range-datechooser";
    import {formatDate} from "../../util/date/dateFunctions";
    import cTextInputComponent from "../../components/form/cTextInputComponent";
    import cAirLine from "../../components/pricing/cAirLine";
    import cAgent from "../../components/form/cAgent";
    import apiGetAllUser from "../../services/apiGetAllUser";
    import cExportExcel from "../../components/excel/cExportExcel";
    import cJsonExcelModal from "../../components/modal/cJsonExcelModal";
    //import cTicketingDetail from "./cTicketingDetail";
    import router, {navigate, goBack} from "../../router/index";

    import apiCancelBooking from "../../services/apiCancelBooking";
    import apiGetTicketingQueueList from "../../services/apiGetTicketingQueueList";
    import cPaginationLenOption from "../../components/dataTable/cPaginationLenOption";
    import apiGetRoutes from "../../services/apiGetRoutes.js";
    import datePickerInput from "../../components/datePicker/datePickerInput";
    import {VMdDateRangePicker} from "material-vue-date-picker";
    import cFullScreen from "../../components/cFullScreen";
    import cHelpTip from "../../components/cHelpTip";
import cManageColumns from "../../components/dataTable/cManageColumns";
import cTable from "../../components/dataTable/cTable";

    export default {
        name: COMPONENT_NAME.C_TICKETING_QUEUE,

        components: {
            Multiselect,
            cAlertModal,
            HotelDatePicker,
            cTextInputComponent,
            cAirLine,
            cAgent,
            cExportExcel,
            cJsonExcelModal,
            //cTicketingDetail,
            cPaginationLenOption,
            datePickerInput,
            VMdDateRangePicker,
            cFullScreen,
            cHelpTip,
            cManageColumns,
            cTable
        },

        props: {
            ticketingQueueResponse: {
                type: Object | Array,
                default: null
            },
            ticketingQueueField: {
                type:  Array,
                default: () => []
            },
            isBooking: {
                type: Boolean,
                default: false
            },
            isTicketNow: {
                type: Boolean,
                default: false
            },
            filterObject: {
                type: Object,
                default: null
            },
            orderStatusCount:null
        },

        data() {
            return {



                refundBookingDet:{
                    [BOOKING_STATUS.REFUND_REQUESTED]:this.$t('cEditTickets.refundRequested'),
                    [BOOKING_STATUS.HOLD_STATUS]:this.$t('cEditTickets.refundProcessing'),
                    [BOOKING_STATUS.TICKET_PENDING]:this.$t('cEditTickets.refundFailed'),
                    [BOOKING_STATUS.BOOKING_CANCELLED]:this.$t('cEditTickets.refundCancelled'),
                    [BOOKING_STATUS.TICKETED_SUCCESS_STATUS]:this.$t('cEditTickets.refundSuccess')

},






exchangeBookingDet:{
      [BOOKING_STATUS.REFUND_REQUESTED]:this.$t('cEditTickets.exchangeRequested'),
    [BOOKING_STATUS.HOLD_STATUS]:this.$t('cEditTickets.exchangeProcessing'),
    [BOOKING_STATUS.TICKET_PENDING]:this.$t('cEditTickets.exchangeFailed'),
     [BOOKING_STATUS.BOOKING_CANCELLED]:this.$t('cEditTickets.exchangeCancelled'),
     [BOOKING_STATUS.TICKETED_SUCCESS_STATUS]:this.$t('cEditTickets.exchangeSuccess')
},
                search:{
                    arrival:null,
                    departure:null
                },
                routesResponse:null,
                lsCountryRoute:[],
                cTicketingTableWatchList:{
                    filteredlistCount:null,
                    itemsPerPage:25,
                    currentPageNum:1
                },
                // isSdate:true,
                // sdate:null,
                ticketingQueueList: [],
                agency: null,
                fromDate: new Date(),
                toDate: new Date(),
                journeyType: {
                    oneWay: TRIP.ONE_WAY,
                    roundTrip: TRIP.ROUND_TRIP,
                    multiCity: TRIP.MULTI_CITY
                },
                jTypeFilterOption: ["One Way", "Round Trip", "Multi City"],
                isShowMoreFilter: false,
                alertValue: null,
                showJsonExcelModal: false,
                jsonData: null,
                jsonFields: null,
                filterOption: {
                    selectedJType: null,
                    selectedAirline: null,
                    agency: null,
                    user: [],
                    selectedUser: null
                },
                // selSortval: null,
                // searchObj: {
                //   orderId: null,
                //   pnr: null,
                //   firstName: null,
                //   lastName: null,
                //   departure: null,
                //   arrival: null,
                //   journeyType: null,
                //   travelDateFrom: null,
                //   travelDateTo: null,
                //   airline: null,
                //   b2bid: this.AGENT_DET ? this.AGENT_DET.b2bid : null,
                //   userId: null,
                //   bookingDateFrom: null,
                //   bookingDateTo: null
                // },
                searchObj: null,
                //isShowTicketingDetail: false,
                ticketingOrderDetail: null,
                selBookingDetail:null,
                isShowCancelAlert:false,
                isBookCancelledAlert:false,
                isBookCancelFailed:false,
                isRetryPaymentAlert:false,
                statusCount:null,
                isLoading:true,
                tickQueueFields:null,
                isBookingDatePickerOpen:false,
                isTravelDatePickerOpen:false,
                isFiltersApplied:false,
                // fullscreen: false

                //filterAlert: null,

                // ticketingQueFilterOption: {
                //   // resId: [{ id: DEFAULT_DROPDOWN_STATUS.ALL }],
                //   // pnr: [{ pnr: DEFAULT_DROPDOWN_STATUS.ALL }],
                //   // passengerName: [{ name: DEFAULT_DROPDOWN_STATUS.ALL }],
                //   // departure: [{dep: DEFAULT_DROPDOWN_STATUS.ALL }],
                //   // arrival: [{arr: DEFAULT_DROPDOWN_STATUS.ALL }],
                //   // journeyType: [{ type: DEFAULT_DROPDOWN_STATUS.ALL }],
                //   // airline: [{ air: DEFAULT_DROPDOWN_STATUS.ALL }],
                //   // userName: [{ user: DEFAULT_DROPDOWN_STATUS.ALL }],
                //   // agentName: [{ agent: DEFAULT_DROPDOWN_STATUS.ALL }]
                //   resId: "",
                //   pnr: "",
                //   passengerName: "",
                //   departure: "",
                //   arrival: "",
                //   journeyType: [],
                //   airline: [],
                //   userName: "",
                //   agentName: ""
                // },
                // selectedTicketQue: {
                //   //   selResId: { id: DEFAULT_DROPDOWN_STATUS.ALL },
                //   //   selPNR: { pnr: DEFAULT_DROPDOWN_STATUS.ALL },
                //   //   selPassengerName: { name: DEFAULT_DROPDOWN_STATUS.ALL },
                //   //   departure: { dep: DEFAULT_DROPDOWN_STATUS.ALL },
                //   //   arrival: { arr: DEFAULT_DROPDOWN_STATUS.ALL },
                //   //   journeyType: { type: DEFAULT_DROPDOWN_STATUS.ALL },
                //   //   airline: { air: DEFAULT_DROPDOWN_STATUS.ALL },
                //   //   userName: { user: DEFAULT_DROPDOWN_STATUS.ALL },
                //   //   agentName: { agent: DEFAULT_DROPDOWN_STATUS.ALL }
                //   selResId: "",
                //   selPNR: "",
                //   selPassengerName: "",
                //   departure: "",
                //   arrival: "",
                //   journeyType: "",
                //   airline: "",
                //   userName: "",
                //   agentName: ""
                // }
                
            };
        },

        methods: {
            ...mapActions("sTicketingQueue", {
     SET_TICK_QUEUE_REQ: "SET_TICK_QUEUE_REQ",
     SET_IS_BOOKING_STATUS: "SET_IS_BOOKING_STATUS"
    //  SET_FILTER_SEARCH_OBJ:"SET_FILTER_SEARCH_OBJ"
    }),
     ...mapActions("cBookingDetail", {
     SET_BOOKING_ROUTE:"SET_FILTER_ROUTE",
     SET_BOOK_TABLE_WATCH_LIST:"SET_TABLE_WATCH_LIST"
    }),
     ...mapActions("cTicketingDetail", {
     SET_TICKETING_ROUTE:"SET_FILTER_ROUTE",
     SET_TICKETING_QUEUE_RES:"SET_TICKETING_QUEUE_RES",
          SET_TQ_TABLE_WATCH_LIST:"SET_TABLE_WATCH_LIST"

   
    }),
    ...mapActions("cBookingDetail",{SET_TKT_REFUND_OBJ:"SET_TKT_REFUND_OBJ",  SET_TKT_EXCHANGE_OBJ:"SET_TKT_EXCHANGE_OBJ"}),
 ...mapActions('sRefundDetail', {SET_REFUND_OBJ:"SET_REFUND_OBJ"}),
 ...mapActions('sExchangeDetail',{SET_EXCHANGE_OBJ:'SET_EXCHANGE_OBJ'}),


 onToggleTravelDatePicker() {
     try {
       if(BaseConfiguration.isDebug) console.log("onToggleTravelDatePicker");
       this.isTravelDatePickerOpen=!this.isTravelDatePickerOpen;
       if(this.isTravelDatePickerOpen){
       addClassToBody(this.$router.currentRoute.name+' '+'overflow-hidden')
       }else{
       addClassToBody(this.$router.currentRoute.name)
       }
     } catch (err) {
             let body = Logger.buildRequest(
               COMPONENT_NAME.C_TICKETING_QUEUE,
               "error in onToggleTravelDatePicker",
               err.toString(),
               "onToggleTravelDatePicker",
               LOG_TYPE.ERROR
             );
             Logger.getResponse(body);
           }
     }, 
     onToggleBookingDatePicker() {
     try {
       if(BaseConfiguration.isDebug) console.log("onToggleBookingDatePicker");
       this.isBookingDatePickerOpen=!this.isBookingDatePickerOpen;
       if(this.isBookingDatePickerOpen){
       addClassToBody(this.$router.currentRoute.name+' '+'overflow-hidden')
       }else{
       addClassToBody(this.$router.currentRoute.name)
       }
     } catch (err) {
             let body = Logger.buildRequest(
               COMPONENT_NAME.C_TICKETING_QUEUE,
               "error in onToggleBookingDatePicker",
               err.toString(),
               "onToggleBookingDatePicker",
               LOG_TYPE.ERROR
             );
             Logger.getResponse(body);
           }
     }, 
 onSaveColumns(pFields) {
    try {
      if(BaseConfiguration.isDebug) console.log("onSaveColumns");
      this.tickQueueFields=pFields;
      

    } catch (err) {
            let body = Logger.buildRequest(
             COMPONENT_NAME.C_TICKETING_QUEUE,
              "error in onSaveColumns",
              err.toString(),
              "onSaveColumns",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
     
    }, 

  navToExchange(pTicketObj)
    {
 
         try {
           if(BaseConfiguration.isDebug) console.log("navToExchange");


           if(pTicketObj)
           {
          this.SET_TKT_EXCHANGE_OBJ(pTicketObj);
          navigate(PATHNAME.EXCHANGE)
           }
             else
           {
               throw 'Invalid Ticket Object '
           }
         } catch (err) {
                 let body = Logger.buildRequest(
                   FILE_NAME.C_TICKETING_QUEUE,
                   "error in navToExchange",
                   err.toString(),
                   "navToExchange",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
         
         
    },


    navToRefund(pTicketObj)
    {
 
         try {
           if(BaseConfiguration.isDebug) console.log("navToRefund");


           if(pTicketObj)
           {
          this.SET_TKT_REFUND_OBJ(pTicketObj);
          navigate(PATHNAME.REFUND)
           }
             else
           {
               throw 'Invalid Ticket Object '
           }
         } catch (err) {
                 let body = Logger.buildRequest(
                   FILE_NAME.C_TICKETING_QUEUE,
                   "error in navToRefund",
                   err.toString(),
                   "navToRefund",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
         
         
    },
    
 cityPickCustomeLabel(option) {
      return `${option.depcode.city} — [${option.depcode.airportcode}]`;
    },


//    toggle () {
//         this.$refs['fullscreen'].toggle() 
//         // recommended
//         // this.fullscreen = !this.fullscreen // deprecated
//       },
// fullscreenChange (fullscreen) {
//         this.fullscreen = fullscreen
//       },

            onChangeTravelDate(pDateList) {
                try {
                    if(BaseConfiguration.isDebug) console.log("onChangeTravelDate");
                    //  console.error(pDateList)
                    //    this.fromDate=pDateList[0]._d;
                    this.getTravelDate(pDateList[0]._d,true);
                    this.getTravelDate(pDateList[1]._d,false);
                    //  this.toDate=pDateList[1]._d;
                     this.onToggleTravelDatePicker();
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in onChangeTravelDate",
                        err.toString(),
                        "onChangeTravelDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            onChangeBookingDate(pDateList) {
                try {
                    if(BaseConfiguration.isDebug) console.log("onChangeBookingDate");
                    //  console.error(pDateList)
                    //    this.fromDate=pDateList[0]._d;
                    this.getBookingDate(pDateList[0]._d,true);
                    this.getBookingDate(pDateList[1]._d,false);
                    this.onToggleBookingDatePicker();
                    //  this.toDate=pDateList[1]._d;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in onChangeBookingDate",
                        err.toString(),
                        "onChangeBookingDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            getMinYear() {
                let retValue;
                try {
                    if(BaseConfiguration.isDebug) console.log("getMinYear");
                    retValue=(new Date().getFullYear()-10)+'';

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in getMinYear",
                        err.toString(),
                        "getMinYear",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getMaxYear(isTravelDate) {
                let retValue;
                try {
                    if(BaseConfiguration.isDebug) console.log("getMaxYear");
                    retValue=isTravelDate?(new Date().getFullYear()+10)+'':(new Date().getFullYear()+1)+'';

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in getMaxYear",
                        err.toString(),
                        "getMaxYear",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            onRetryPayment() {
                try {
                    if(BaseConfiguration.isDebug) console.log("onRetryPayment");
                    this.emitNav(this.selBookingDetail);
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in onRetryPayment",
                        err.toString(),
                        "onRetryPayment",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            checkHoldByOrderStatus(pStatus) {
                try {
                    if (BaseConfiguration.isDebug) console.log("checkHoldByOrderStatus");
                    let retValue;
                    if (pStatus && pStatus.orderType==BOOKING_ORDER_TYPE.BOOKING_ORDER) {

                        if (pStatus.status == BOOKING_STATUS.HOLD_STATUS)
                            retValue = true;
                        else
                            retValue = false;

                    }
                    return retValue;

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_DETAIL,
                        "error in checkHoldByOrderStatus",
                        err.toString(),
                        "checkHoldByOrderStatus",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

         



            getRefundStatus(pTicket) {
                let retValue=false;

                try {
                    if(BaseConfiguration.isDebug) console.log("getRefundStatus");


                    if(pTicket && pTicket.status && pTicket.orderType==BOOKING_ORDER_TYPE.BOOKING_ORDER)
                    {
                        retValue= (pTicket.status==   BOOKING_STATUS.TICKETED_SUCCESS_STATUS) ;

                    }



                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in getRefundStatus",
                        err.toString(),
                        "getRefundStatus",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getRetryBtnStatus(pTicketItem) {
                let retValue;

                try {
                    if(BaseConfiguration.isDebug) console.log("getRetryBtnStatus");
                    if(pTicketItem&&pTicketItem.status && pTicketItem.orderType==BOOKING_ORDER_TYPE.BOOKING_ORDER){
                        if(pTicketItem.status==BOOKING_STATUS.PAYMENT_STATUS_PENDING){
                            retValue=true;
                        }else{
                            retValue=false;
                        }
                    }else{
                        retValue=false;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in getRetryBtnStatus",
                        err.toString(),
                        "getRetryBtnStatus",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getExcelFileName(pFileName) {
                let retValue;

                try {
                    if(BaseConfiguration.isDebug) console.log("getExcelFileName");
                    let excelDate=this.$options.filters.formatDate(new Date());
                    retValue=pFileName+' - '+excelDate+'.xlsx';
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in getExcelFileName",
                        err.toString(),
                        "getExcelFileName",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getArrivalRoute(pArrival) {
                try {
                    if(BaseConfiguration.isDebug) console.log("getArrivalRoute");
                    if(pArrival&&pArrival.depcode&&pArrival.depcode.airportcode){
                        this.searchObj.arrival=  pArrival.depcode.airportcode;
                    }
                    this.isDpO

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in getArrivalRoute",
                        err.toString(),
                        "getArrivalRoute",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            getDepartureRoute(pDeparture) {
                try {
                    if(BaseConfiguration.isDebug) console.log("getArrivalRoute");
                    if(pDeparture&&pDeparture.depcode&&pDeparture.depcode.airportcode){
                        this.searchObj.departure=  pDeparture.depcode.airportcode;

                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in getArrivalRoute",
                        err.toString(),
                        "getArrivalRoute",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            onPaginationChange(pItemsPerPage) {
                try {
                    if(BaseConfiguration.isDebug) console.log("onPaginationChange");
                    this.cTicketingTableWatchList.itemsPerPage=pItemsPerPage;

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in onPaginationChange",
                        err.toString(),
                        "onPaginationChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            onPageChange(pPageNum) {
                try {
                    if(BaseConfiguration.isDebug) console.log("onPageChange");
                    this.cTicketingTableWatchList.currentPageNum=pPageNum;
                    
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in onPageChange",
                        err.toString(),
                        "onPageChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getFilteredAgentCount(pFilteredItems) {
                try {
                    if(BaseConfiguration.isDebug) console.log("getFilteredAgentCount");
                    this.cTicketingTableWatchList.filteredlistCount=pFilteredItems.length;

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in getFilteredAgentCount",
                        err.toString(),
                        "getFilteredAgentCount",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            onHideCancelledAlert() {
                try {
                    if(BaseConfiguration.isDebug) console.log("onHideCancelledAlert");
                    this.isBookCancelledAlert=false;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in onHideCancelledAlert",
                        err.toString(),
                        "onHideCancelledAlert",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            onHideBookCancelFailed() {
                try {
                    if(BaseConfiguration.isDebug) console.log("onHideBookCancelFailed");
                    this.isBookCancelFailed=false;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in onHideBookCancelFailed",
                        err.toString(),
                        "onHideBookCancelFailed",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

     getCancelBtnStatus(pTicketItem) {
        let retValue;

      try {
        if(BaseConfiguration.isDebug) console.log("getCancelBtnStatus");
       if(pTicketItem&&pTicketItem.status && pTicketItem.orderType==BOOKING_ORDER_TYPE.BOOKING_ORDER ){
           if(pTicketItem.status==BOOKING_STATUS.HOLD_STATUS||pTicketItem.status==BOOKING_STATUS.PAYMENT_STATUS_PENDING){
               retValue=true;
           }else{
               retValue=false;
           }
       }else{
           retValue=false;
       }

      } catch (err) {
              let body = Logger.buildRequest(
                FILE_NAME.C_TICKETING_QUEUE,
                "error in getCancelBtnStatus",
                err.toString(),
                "getCancelBtnStatus",
                LOG_TYPE.ERROR
              );
              Logger.getResponse(body);
            }
        return retValue;
      },
           
            onRejectCancel() {
                try {
                    if(BaseConfiguration.isDebug) console.log("onRejectCancel");
                    this.isShowCancelAlert=false;
                    this.isBookCancelFailed=false;
                    this.isBookCancelledAlert=false;
                    this.isRetryPaymentAlert=false;

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in onRejectCancel",
                        err.toString(),
                        "onRejectCancel",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                },

           getExchangeStatus(pTicket) {
         let retValue=false;

          try {
            if(BaseConfiguration.isDebug) console.log("getExchangeStatus");


            if(pTicket && pTicket.status && pTicket.orderType==BOOKING_ORDER_TYPE.BOOKING_ORDER)
            {
             retValue= (pTicket.status==   BOOKING_STATUS.TICKETED_SUCCESS_STATUS) ;
             
            }


      
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.C_TICKETING_QUEUE,
                    "error in getExchangeStatus",
                    err.toString(),
                    "getExchangeStatus",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
          }, 

        
            async getCancelBooking(pOrderId) {
                let returnValue;
                try {
                    if(BaseConfiguration.isDebug) console.log("getCancelBooking");
                    let cancelBookingReq=  apiCancelBooking.buildRequest(pOrderId);
                    if(cancelBookingReq){
                        let cancelBookingRes= await apiCancelBooking.getResponse(cancelBookingReq);
                        //    let cancelBookingRes= {data:{"data":false,"status":"Success"}}
                        if (VALIDATE_SUCCESS_RES(cancelBookingRes)) {//VALIDATE_SUCCESS_RES(cancelBookingRes)
                            returnValue = cancelBookingRes.data.data;
                        } else {
                            let error = getErrorMessage(cancelBookingRes);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                getErrorAlertValue(error);
                            }
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in getCancelBooking",
                        err.toString(),
                        "getCancelBooking",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;

            },
            async getTicketingQueueList(ticketingObj) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getTicketingQueueList");
                    //let retValue;
                    //let TicketQList;
                    // if(this.AGENT_SIGNIN_RES && this.AGENT_DET){
                    //   ticketingObj.b2bid = this.AGENT_DET.b2bid;
                    // }
                    let ticketQReq = apiGetTicketingQueueList.buildRequest(ticketingObj);

                    if (ticketQReq) {
                        let ticketQRes = await apiGetTicketingQueueList.getResponse(
                            ticketQReq
                        );
                        if (VALIDATE_SUCCESS_RES(ticketQRes)) {
                            let ticketingQueueResponse = ticketQRes.data.data.bookings;
                            this.SET_TICKETING_QUEUE_RES(ticketQRes.data.data)

                            this.statusCount=ticketQRes.data.data.statusCount;
                            ticketingQueueResponse = OrderByList(ticketingQueueResponse,'ticketingdeadline','desc');
                            this.ticketingQueueList = cloneData(ticketingQueueResponse);
                            this.jsonData = this.getJsonData(ticketingQueueResponse);
                            //                      this.ticketingQueueList = null;

                            //                   let that = this;
                            // Vue.nextTick(() => {///for a smooth update
                            //                        this.ticketingQueueList = ticketingQueueResponse;
                            //                     });

                            // this.showAlert(null);
                            // this.showAcknowledgeAlert();
                        } else {
                            let error = getErrorMessage(ticketQRes);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }

                    //return TicketQList;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.TICKETING_QUEUE,
                        "error in getTicketingQueueList",
                        err.toString(),
                        "getTicketingQueueList",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            async onCancelBooking() {
                try {
                    if(BaseConfiguration.isDebug) console.log("onCancelBooking");

            //    if(pTicket && pTicket.status && pTicket.orderType==BOOKING_ORDER_TYPE.BOOKING_ORDER)
            //       {
            //  retValue= (pTicket.status==   BOOKING_STATUS.TICKETED_SUCCESS_STATUS) || (pTicket.status==BOOKING_STATUS.TICKET_PENDING);
             
            // }
                    let retCancelledbookRes= await this.getCancelBooking(this.selBookingDetail.orderId);
                    this.isShowCancelAlert=false;

                    if(retCancelledbookRes){
                        this.isBookCancelledAlert=true;
                        this.onSearch();
                        //    await this.getTicketingQueueList(this.filterObject);
                    }else{
                        // this.isBookCancelFailed=true;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in onCancelBooking",
                        err.toString(),
                        "onCancelBooking",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            onShowRetryPayModel(pItem) {
                try {
                    if(BaseConfiguration.isDebug) console.log("onShowRetryPayModel");
                    this.selBookingDetail=pItem;
                    this.isRetryPaymentAlert=true;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in onShowRetryPayModel",
                        err.toString(),
                        "onShowRetryPayModel",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            onShowCancelConfirmation(pItem) {
                try {
                    if(BaseConfiguration.isDebug) console.log("onShowCancelConfirmation");
                    this.selBookingDetail=pItem;
                    this.isShowCancelAlert=true;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in onShowCancelConfirmation",
                        err.toString(),
                        "onShowCancelConfirmation",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            showAlert(val) {
                this.alertValue = val;
            },

            toggleJsonExcelModal() {
                this.showJsonExcelModal = !this.showJsonExcelModal;
            },

            sortList(pSortObj) {
                try {
                    if (BaseConfiguration.isDebug) console.log("sortList");
                    let sortedTicketingQueueList = [];
                    // let retValue;
                    // console.log(pSortObj)
                    if (pSortObj && pSortObj.column && (pSortObj.column == "airline" || pSortObj.column == "departuredate" || pSortObj.column == "pnr" || pSortObj.column == "ticketNumber")) {

                        let sortArray = [];
                        for (let index = 0; index < this.ticketingQueueList.length; index++) {

                            sortArray = sortArray.concat(this.ticketingQueueList[index].FlightDetails[0]);

                        }
                        sortArray = OrderByList(sortArray, pSortObj.column, pSortObj.asc ? "asc" : "desc")
                        // console.log(sortArray)


                        for (let i = 0; i < sortArray.length; i++) {
                            const sortList = sortArray[i];

                            let ticketingObj = this.ticketingQueueList.find((val) => val.FlightDetails[0].pnr == sortList.pnr)
                            if (ticketingObj) {
                                sortedTicketingQueueList.push(ticketingObj)
                            }
                        }
                    } else {
                        sortedTicketingQueueList = this.ticketingQueueList;
                    }
                    sortedTicketingQueueList = removeDuplicates(sortedTicketingQueueList, "orderId");
                    this.ticketingQueueList = sortedTicketingQueueList;

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in sortList",
                        err.toString(),
                        "sortList",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            checkStatus(pStatus, isBooking) {
                try {
                    if (BaseConfiguration.isDebug) console.log("checkStatus");
                    let retValue;
                    if (pStatus) {
                        if (isBooking) {
                            if (pStatus.bookingStatus == BOOKING_STATUS.TICKETED_SUCCESS)
                                retValue = false;
                            else
                                retValue = true;
                        } else {
                            retValue = true;
                        }
                    }
                    return retValue;

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in checkStatus",
                        err.toString(),
                        "checkStatus",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            getStatusClass(pStatus) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getStatusClass");
                    let retValue;
                    if (pStatus && pStatus.status) {
                        if (pStatus.status == BOOKING_STATUS.HOLD_STATUS) {
                            retValue = 'partial_paid'
                        } else if (pStatus.status == BOOKING_STATUS.TICKETED_SUCCESS_STATUS) {
                            retValue = 'paid'
                        } else if (pStatus.status == BOOKING_STATUS.TICKET_PENDING) {
                            retValue = 'unpaid'
                        }else if (pStatus.status == BOOKING_STATUS.BOOKING_CANCELLED) {
                            retValue = 'unpaid'

                        }else if (pStatus.status == BOOKING_STATUS.PAYMENT_STATUS_PENDING) {
                            retValue = 'unpaid'
                        }
                        else if (pStatus.orderStatus == BOOKING_STATUS.PAYMENT_STATUS_PENDING) {
                            retValue = 'unpaid'
                        }

                        else if(pStatus.status==BOOKING_STATUS.REFUND_REQUESTED)
                        {
                             retValue = 'partial_paid'
                        }
                    }
                    return retValue;

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in getStatusClass",
                        err.toString(),
                        "getStatusClass",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            getPassengerCount(pPax) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getPassengerCount");
                    //let retValue;
                    let paxCount = 0;
                    if (pPax) {
                        if (pPax.adultscount)
                            paxCount = paxCount + pPax.adultscount;
                        if (pPax.childcount)
                            paxCount = paxCount + pPax.childcount;
                        if (pPax.infantcount)
                            paxCount = paxCount + pPax.infantcount
                    }
                    if (paxCount > 1)
                        paxCount = paxCount + ' passengers';
                    else
                        paxCount = paxCount + ' passenger';
                    return paxCount;

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in getPassengerCount",
                        err.toString(),
                        "getPassengerCount",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            getTravelDate(pDate, isFromDate) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getDate");
                    // let retValue;
                    if (pDate) {
                        if (isFromDate == true) {
                            this.searchObj.travelDateFrom = new Date(pDate);
                            this.searchObj.travelDateTo = null;
                        }
                        if (isFromDate == false)
                            this.searchObj.travelDateTo = new Date(pDate);
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in getDate",
                        err.toString(),
                        "getDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            getBookingDate(pDate, isFromDate) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getDate");
                    // let retValue;
                    if (pDate) {
                        if (isFromDate == true) {
                            this.searchObj.bookingDateFrom = new Date(pDate);
                            this.searchObj.bookingDateTo = null;
                        }
                        if (isFromDate == false)
                            this.searchObj.bookingDateTo = new Date(pDate);
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in getDate",
                        err.toString(),
                        "getDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            onChangeJType(pType) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onChangeJType");
                    //let retValue;
                    if (pType) {
                        this.filterOption.selectedJType = pType;
                        this.searchObj.journeyType =
                            pType == this.jTypeFilterOption[0]
                                ? TRIP.ONE_WAY
                                : pType == this.jTypeFilterOption[1]
                                ? TRIP.ROUND_TRIP
                                : pType == this.jTypeFilterOption[2]
                                    ? TRIP.MULTI_CITY
                                    : null;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in onChangeJType",
                        err.toString(),
                        "onChangeJType",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                //return retValue;
            },

            onChangeAirline(pAirline) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onChangeAirline");
                    //let retValue;
                    if (pAirline) {
                        this.filterOption.selectedAirline = pAirline;
                        this.searchObj.airline = pAirline.airline_code
                            ? pAirline.airline_code
                            : null;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in onChangeAirline",
                        err.toString(),
                        "onChangeAirline",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                //return retValue;
            },

            onChangeAgent(pAgent) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onChangeAgent");
                    //let retValue;
                    if (pAgent) {
                        this.filterOption.agency=pAgent;
                        if(pAgent[0].b2bid) {
                        this.searchObj.b2bid=[];
                        this.searchObj.b2bGroupId=null
                        }
                        for (let i = 0; i < pAgent.length; i++) {
                            if(pAgent[i].b2bGroupid){
                                this.searchObj.b2bid=null;
                                this.searchObj["b2bGroupId"] = pAgent[i].b2bGroupid;
                            }else{
                            this.searchObj.b2bid.push(pAgent[i].b2bid);
                            }
                        }
                        // this.searchObj.b2bid = this.searchObj.b2bid.toString();
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in onChangeAgent",
                        err.toString(),
                        "onChangeAgent",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            onChangeUser(pUser) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onChangeUser");
                    //let retValue;
                    if (pUser) {
                        this.filterOption.selectedUser = pUser;
                        this.searchObj.userId = pUser.userid;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in onChangeUser",
                        err.toString(),
                        "onChangeUser",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            onSearch() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onSearch");
                    // let retValue;
                          

                    this.statusCount=null;
                    let search = this.searchObj;
                    if(this.isBooking){
                        this.SET_BOOKING_ROUTE(this.search)

                    }else{
                        this.SET_TICKETING_ROUTE(this.search)

                    }
                    // this.SET_FILTER_SEARCH_OBJ(search);
                    for (let index = 0; index < Object.keys(search).length; index++) {
                        const srchObj = Object.values(search)[index];
                        if(Object.keys(search) == 'b2bid') {
                            const srchObj = Object.values(search)[index];
                        }
                        const srchKey = Object.keys(search)[index];
                        // console.log(srchObj,srchKey)
                        if (
                            srchKey !== "travelDateFrom" &&
                            srchKey !== "travelDateTo" &&
                            srchKey !== "bookingDateFrom" &&
                            srchKey !== "bookingDateTo" &&
                            srchKey !== "journeyType" && 
                            srchKey !== "b2bGroupId"
                        ) {
                            // srchObj = srchObj ? srchObj.trim() : srchObj;
                            if (srchObj) {
                                if(srchObj.length==0) {
                                    srchObj = srchObj.trim();

                                }else{
                                    srchObj = srchObj;
                                }
                            } else {
                                srchObj = srchObj;
                            }
                        }
                        if (srchObj) {
                             this.isLoading=true;
                            // this.filterAlert = null;
                            this.$emit("search", this.searchObj);
                            break;
                            // }else {
                            //     this.filterAlert = this.$t('ticketingQueue.filterAlert');
                        }

                        else{
                               this.$emit("search", null);
                        }

                    }
                   

                    //  if(search.orderId || search.pnr || search.firstName || search.lastName || search.departure || search.arrival || search.journeyType || search.travelDateFrom || search.travelDateTo || search.airline || search.b2bid || search.userId || search.bookingDateFrom || search.bookingDateTo){
                    //    this.$emit("search", this.searchObj);
                    //  }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in onSearch",
                        err.toString(),
                        "onSearch",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            clearFilter() {
                try {
                    if (BaseConfiguration.isDebug) console.log("clearFilter");
                    //let retValue;
                    this.searchObj.orderId = null;
                    this.searchObj.pnr = null;
                    this.searchObj.firstName = null;
                    this.searchObj.lastName = null;
                    this.searchObj.departure = null;
                    this.searchObj.arrival = null;
                    this.searchObj.journeyType = null;
                    this.searchObj.travelDateFrom = null;
                    this.searchObj.travelDateTo = null;
                    this.searchObj.airline = null;
                    this.searchObj.b2bid = null;
                    this.searchObj.userId = null;
                    this.searchObj.ticketNumber = null;
                    this.searchObj.bookingDateFrom = null;
                    this.searchObj.bookingDateTo = null;
                    this.search.departure=null;
                    this.search.arrival=null;
                    this.searchObj.b2bGroupId=null;
                    // this.$refs.travelDatePicker.checkIn = null;
                    // this.$refs.travelDatePicker.checkOut = null;
                    // this.$refs.bookingDatePicker.checkIn = null;
                    // this.$refs.bookingDatePicker.checkOut = null;

                    this.filterOption.selectedJType = null;
                    this.filterOption.selectedAirline = null;
                    this.filterOption.selectedUser = null;
                    this.filterOption.agency = null;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in clearFilter",
                        err.toString(),
                        "clearFilter",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                //return retValue;
            },

            async getAllUser() {
                let returnValue;
                try {
                    let allUserRequest = apiGetAllUser.buildRequest();

                    if (allUserRequest) {
                        let allUserResponse = await apiGetAllUser.getResponse(allUserRequest);
                        if (VALIDATE_SUCCESS_RES(allUserResponse)) {
                            returnValue = allUserResponse.data.data.users;
                            this.showAlert(null);
                        } else {
                            let error = getErrorMessage(allUserResponse);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.MANAGE_USERS,
                        "error in  get All User",
                        err.toString(),
                        "getAllUser",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },

            getJsonData(TcktRes) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getJsonData");
                    let jData = [];
                    if (TcktRes) {
                        jData = JSON.parse(JSON.stringify(TcktRes));
                        this.jsonFields = this.isBooking
                            ? this.getBookingJsonField()
                            : this.getTicketingJsonField();
                        return jData;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in getJsonData",
                        err.toString(),
                        "getJsonData",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getTicketingOrderDetails(ptcktObj){


                try{


                    if(ptcktObj)
                    {

               switch(ptcktObj.orderType)
                {
              case  BOOKING_ORDER_TYPE.BOOKING_ORDER:{



                    

                                if(ptcktObj && this.isTicketNow==false){
                                    this.ticketingOrderDetail = ptcktObj;
                                    this.SET_TICK_QUEUE_REQ(ptcktObj);
                                    if(!this.isBooking) {
                                        // navigate(PATHNAME.TICKETING_QUEUE_DETAIL);
                                        this.SET_IS_BOOKING_STATUS(false);
                                        navigate(PATHNAME.BOOKING_DETAILS)
                                    }

                                    else
                                    {
                                        // navigate(PATHNAME.MY_BOOKING_DETAIL)
                                        this.SET_IS_BOOKING_STATUS(true);
                                       navigate(PATHNAME.BOOKING_DETAILS)
                                    }
                                }


                          
                            

                                break;
              }
                            




                           

                   case BOOKING_ORDER_TYPE.REFUND:{
                        
                  {
                     
                        this.SET_REFUND_OBJ(ptcktObj);
                      navigate(PATHNAME.REFUND_DET)
                  }

                      break;
                   }
                  case BOOKING_ORDER_TYPE.EXCHANGE:{
                      
                  {
                     
                        this.SET_EXCHANGE_OBJ(ptcktObj);
                      navigate(PATHNAME.EXCHANGE_DET)
                  }

                      break;
                   }


                        }

                        /*
                                        if(ptcktObj && this.isTicketNow==false){
                                            this.ticketingOrderDetail = ptcktObj;
                                            this.SET_TICK_QUEUE_REQ(ptcktObj);
                                            if(!this.isBooking) {
                                            navigate(PATHNAME.TICKETING_QUEUE_DETAIL);
                                            }else if(this.isBooking) {


                                                    if(ptcktObj&& ptcktObj.orderType==BOOKING_STATUS.REFUND_ORDER)
                                                    {

                                                       // ptcktObj.viewOnly=true;
                                                   this.SET_TKT_REFUND_OBJ(ptcktObj);
                                              navigate(PATHNAME.REFUND_DET)
                                                    }

                                                 else
                                                 {
                                                navigate(PATHNAME.MY_BOOKING_DETAIL)
                                                 }
                                            }
                         */


                        // this.toggleShowTicketingDetail();

                        //    this.isShowTicketingDetail = true;

                    }}

                catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in getTicketingOrderDetails",
                        err.toString(),
                        "getTicketingOrderDetails",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            /*toggleShowTicketingDetail(){
                this.isShowTicketingDetail = !this.isShowTicketingDetail;
            },*/

            getTicketingJsonField() {
                try {
                    if (BaseConfiguration.isDebug) console.log("getTicketingJsonField");
                    let jsonFiled;

                    jsonFiled = {
                        "Booking Date": {
                            field: "bookingDate",
                            callback: value => {
                                return formatDate(new Date(value), DATE_TIME_FORMAT.DATE_TIME_MINS);
                            }
                        },
                        "Reservation ID": "orderId",
                        "Passenger Name": "passengername",
                        Passengers: {
                            callback: value => {
                                let paxCount = 0;
                                if (value.adultscount)
                                    paxCount = paxCount + value.adultscount;
                                if (value.childcount)
                                    paxCount = paxCount + value.childcount;
                                if (value.infantcount)
                                    paxCount = paxCount + value.infantcount;

                                if (paxCount > 1)
                                    paxCount = paxCount ;
                                //    paxCount = paxCount + ' passengers';

                                else
                                    paxCount = paxCount ;
                                // paxCount = paxCount + ' passenger';

                                return paxCount;
                            }
                        },
                        "Mail ID": "contactmail",
                        "Mobile Number": "contactnumber",
                        Departure: {
                            field: "FlightDetails",
                            callback: value => {
                                // for (let index = 0; index < value.length; index++) {
                                if (value[0].departure) return value[0].departure;
                                else return "-";
                                // }
                            }
                        },
                        Arrival: {
                            field: "FlightDetails",
                            callback: value => {
                                // for (let index = 0; index < value.length; index++) {
                                if (value && value.length > 1 && value[value.length - 1].departure) return value[value.length - 1].departure
                                else if (value && value[0].arrival) return value[0].arrival;
                                else return "-";
                                // }
                            }
                        },
                        Airlines: {
                            field: "FlightDetails",
                            callback: value => {
                                let airline = "";
                                for (let index = 0; index < value.length; index++) {
                                    const flight = value[index];
                                    if (index != 0 && flight.airline) airline = airline + ",";
                                    if (flight.airline) airline = airline + flight.airline;
                                }
                                airline = airline
                                    .toString()
                                    .split(",")
                                    .join("\n");
                                return airline;
                            }

                        },
                        "Journey Type": {
                            field: "journeytype",
                            callback: value => {
                                value =
                                    value == this.journeyType.oneWay
                                        ? this.jTypeFilterOption[0]
                                        : value == this.journeyType.roundTrip
                                        ? this.jTypeFilterOption[1]
                                        : value == this.journeyType.multiCity
                                            ? this.jTypeFilterOption[2]
                                            : null;
                                return value;
                            }
                        },
                        "Departure Date": {
                            field: "FlightDetails",
                            callback: value => {
                                // for (let index = 0; index < value.length; index++) {
                                if (value[0].departuredate)
                                    return formatDate(
                                        new Date(value[0].departuredate),
                                        DATE_TIME_FORMAT.DATE_TIME_MINS
                                    );
                                else return "-";
                                //}
                            }
                        },
                        "Return Date": {
                            field: "FlightDetails",
                            callback: value => {
                                // for (let index = 0; index < value.length; index++) {
                                if (value && value.length > 1 && value[value.length - 1].departuredate)
                                    return formatDate(
                                        new Date(value[value.length - 1].departuredate),
                                        DATE_TIME_FORMAT.DATE_TIME_MINS
                                    );
                                else if (value && value[0].returndate)
                                    return formatDate(
                                        new Date(value[0].returndate),
                                        DATE_TIME_FORMAT.DATE_TIME_MINS
                                    );
                                else return "-";
                                //}
                            }
                        },
                        PNR: {
                            field: "FlightDetails",
                            callback: value => {
                                let pnr = "";
                                for (let index = 0; index < value.length; index++) {
                                    const flight = value[index];
                                    if (index != 0) pnr = pnr + ",";
                                    if (flight.pnr) pnr = pnr + flight.pnr;
                                }
                                pnr = pnr
                                    .toString()
                                    .split(",")
                                    .join("\n");
                                return pnr;
                            }
                        },
                        "Ticketing Deadline": {
                            field: "ticketingdeadline",
                            callback: value => {
                                // for (let index = 0; index < value.length; index++) {
                                if (value)
                                    return  this.$options.filters.formatDateTimeTZ(
                                        new Date(value),
                                        DATE_TIME_FORMAT.DATE_TIME_MINS
                                    );
                                else return "-";
                                //}
                            }
                        },
                        Currency: "currency",
                        Amount: {
                            callback: value => {
                                let amount;
                                if (value.amount) {
                                    if (value.currency) {
                                        amount = this.$options.filters.formatNumber(value.amount, value.currency)
                                    } else
                                        amount = value.amount;
                                }
                                return amount;
                            }
                        },
                        User: "username",
                        agency: "agencyname",
                        status: "bookingStatus"
                    };

                    return jsonFiled;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in getTicketingJsonField",
                        err.toString(),
                        "getTicketingJsonField",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            getBookingJsonField() {
                try {
                    if (BaseConfiguration.isDebug) console.log("getBookingJsonField");
                    let jsonFiled;

                    jsonFiled = {
                        "Booking Date": {
                            field: "bookingDate",
                            callback: value => {
                                return formatDate(new Date(value), DATE_TIME_FORMAT.DATE_TIME_MINS);
                            }
                        },
                        "Reservation ID": "orderId",
                        "Passenger Name": "passengername",
                        Passengers: {
                            callback: value => {
                                let paxCount = 0;
                                if (value.adultscount)
                                    paxCount = paxCount + value.adultscount;
                                if (value.childcount)
                                    paxCount = paxCount + value.childcount;
                                if (value.infantcount)
                                    paxCount = paxCount + value.infantcount;

                                if (paxCount > 1)
                                    paxCount = paxCount ;
                                else
                                    paxCount = paxCount ;

                                return paxCount;
                            }
                        },
                        "Mail ID": "contactmail",
                        "Mobile Number": "contactnumber",
                        Departure: {
                            field: "FlightDetails",
                            callback: value => {
                                // for (let index = 0; index < value.length; index++) {
                                if (value[0].departure) return value[0].departure;
                                else return "-";
                                // }
                            }
                        },
                        Arrival: {
                            field: "FlightDetails",
                            callback: value => {
                                // for (let index = 0; index < value.length; index++) {
                                if (value && value.length > 1 && value[value.length - 1].departure) return value[value.length - 1].departure
                                else if (value[0].arrival) return value[0].arrival;
                                else return "-";
                                // }
                            }
                        },
                        Airlines: {
                            field: "FlightDetails",
                            callback: value => {
                                let airline = "";
                                for (let index = 0; index < value.length; index++) {
                                    const flight = value[index];
                                    if (index != 0 && flight.airline) airline = airline + ",";
                                    if (flight.airline) airline = airline + flight.airline;
                                }
                                airline = airline
                                    .toString()
                                    .split(",")
                                    .join("\n");
                                return airline;
                            }

                        },
                        "Journey Type": {
                            field: "journeytype",
                            callback: value => {
                                value =
                                    value == this.journeyType.oneWay
                                        ? this.jTypeFilterOption[0]
                                        : value == this.journeyType.roundTrip
                                        ? this.jTypeFilterOption[1]
                                        : value == this.journeyType.multiCity
                                            ? this.jTypeFilterOption[2]
                                            : null;
                                return value;
                            }
                        },
                        "Departure Date": {
                            field: "FlightDetails",
                            callback: value => {
                                // for (let index = 0; index < value.length; index++) {
                                if (value[0].departuredate)
                                    return formatDate(
                                        new Date(value[0].departuredate),
                                        DATE_TIME_FORMAT.DATE_TIME_MINS
                                    );
                                else return "-";
                                //}
                            }
                        },
                        "Return Date": {
                            field: "FlightDetails",
                            callback: value => {
                                // for (let index = 0; index < value.length; index++) {
                                if (value && value.length > 1 && value[value.length - 1].departuredate)
                                    return formatDate(
                                        new Date(value[value.length - 1].departuredate),
                                        DATE_TIME_FORMAT.DATE_TIME_MINS
                                    );
                                else if (value && value[0].returndate)
                                    return formatDate(
                                        new Date(value[0].returndate),
                                        DATE_TIME_FORMAT.DATE_TIME_MINS
                                    );
                                else return "-";
                                //}
                            }
                        },
                        "PNR/Itinerary": {
                            field: "FlightDetails",
                            callback: value => {
                                let pnr = "";
                                for (let index = 0; index < value.length; index++) {
                                    const flight = value[index];
                                    if (index != 0 && flight.pnr) pnr = pnr + ",";
                                    if (flight.pnr) pnr = pnr + flight.pnr;
                                }
                                pnr = pnr
                                    .toString()
                                    .split(",")
                                    .join("\n");
                                return pnr;
                            }
                        },
                        "Ticket Number": {
                            field: "FlightDetails",
                            callback: value => {
                                let tcktNo = "";
                                for (let index = 0; index < value.length; index++) {
                                    const flight = value[index];
                                    if (index != 0 && flight.ticketnumbers) tcktNo = tcktNo + ",";
                                    if (flight.ticketnumbers)
                                        tcktNo = tcktNo + flight.ticketnumbers;
                                }
                                tcktNo = tcktNo
                                    .toString()
                                    .split(",")
                                    .join("\n");
                                return tcktNo;
                            }
                        },
                        Currency: "currency",
                        Amount: {
                            callback: value => {
                                let amount;
                                if (value.amount) {
                                    if (value.currency) {
                                        amount = this.$options.filters.formatNumber(value.amount, value.currency)
                                    } else
                                        amount = value.amount;
                                }
                                return amount;
                            }
                        },
                        By: "username",
                        agency: "agencyname",
                        status: "bookingStatus"
                    };

                    return jsonFiled;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in getBookingJsonField",
                        err.toString(),
                        "getBookingJsonField",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            assigni18nObjByLang() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("assigni18nObjByLang");

                    retValue = {
                        night: this.$t("flightDatePicker.night"),
                        nights: this.$t("flightDatePicker.nights"),
                        "day-names": [
                            this.$t("flightDatePicker.sun"),
                            this.$t("flightDatePicker.mon"),
                            this.$t("flightDatePicker.tue"),
                            this.$t("flightDatePicker.wed"),
                            this.$t("flightDatePicker.thur"),
                            this.$t("flightDatePicker.fri"),
                            this.$t("flightDatePicker.sat")
                        ],
                        "check-in": "From date",
                        "check-out": "To date",
                        "month-names": [
                            this.$t("flightDatePicker.jan"),
                            this.$t("flightDatePicker.feb"),
                            this.$t("flightDatePicker.mar"),
                            this.$t("flightDatePicker.apr"),
                            this.$t("flightDatePicker.may"),
                            this.$t("flightDatePicker.jun"),
                            this.$t("flightDatePicker.july"),
                            this.$t("flightDatePicker.aug"),
                            this.$t("flightDatePicker.sep"),
                            this.$t("flightDatePicker.oct"),
                            this.$t("flightDatePicker.nov"),
                            this.$t("flightDatePicker.dec")
                        ]
                    };
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in assigni18nObjByLang",
                        err.toString(),
                        "assigni18nObjByLang",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            emitNav(item) {
                
                this.$emit("nav", item);
            },

            emitToSysTcktNow(item) {
                this.$emit("navToSysTktNow",item);
            },

            emitAlertModal(resId) {
                if (resId)
                    this.$emit(
                        "showModal",
                        ALERT_MODAL_STATUS.INFO,
                        this.$t("ticketingQueue.cancelConfirm", {resId: resId})
                    );
            },

            getPropToSortUsers(pUsers) {
                try {
                    if(BaseConfiguration.isDebug) console.log("getPropToSortUsers");
                    if(pUsers.firstname) {
                        return pUsers.firstname.toLowerCase();
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in getPropToSortUsers",
                        err.toString(),
                        "getPropToSortUsers",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            ///to get number of routes response from api
            async getRoutesResponse() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getRoutesResponse");

                    let getRoutesRequest = apiGetRoutes.buildRequest();

                    if (getRoutesRequest) {
                        // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
                        let getRouteResponse = await apiGetRoutes.getResponse(
                            getRoutesRequest
                        );

                        if (VALIDATE_SUCCESS_RES(getRouteResponse)) {
                            // this.SET_AGENCY_RES(getRoutesResponse); //save res in store

                            retValue = getRouteResponse.data.data;
                            // this.SET_ROUTES_OBJ(retValue);
                        } else {
                            let error = getErrorMessage(getRouteResponse);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error while getting response from get Routes response API",
                        err.toString(),
                        "getRoutesResponse",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
///method to get routes for particular country
            getRoutesByCountryCode() {
                try {
                    if (BaseConfiguration.isDebug) console.log("getRoutesByCountryCode");

                    // this.lsCountryRoute = []; //to clear the list

                    let countries = this.routesResponse.countries;
                    let airports = this.routesResponse.airports;
                    let routes = this.routesResponse.routes;
                    let listOfRoutes = [];

                    var routesGrpByList = GroupByList(routes, "depcode", "arrCombination"); ///list of routes grouped by depcode
                    for (let i = 0; i < Object.keys(countries).length; i++) {
                        for (let j = 0; j < Object.keys(airports).length; j++) {
                            let lsArrCodes = [];
                            if (
                                Object.values(countries)[i].countrycode ==
                                Object.values(airports)[j].countryid
                            ) {
                                for (let k = 0; k < routesGrpByList.length; k++) {
                                    if (
                                        routesGrpByList[k].depcode ==
                                        Object.values(airports)[j].airportcode
                                    ) {
                                        for (
                                            let l = 0;
                                            l < routesGrpByList[k].arrCombination.length;
                                            l++
                                        ) {
                                            lsArrCodes.push(
                                                routesGrpByList[k].arrCombination[l].arrcode
                                            );
                                        }
                                    }
                                }

                                let lsArrCodesForDep = {
                                    // "routes": 1,
                                    depcode: Object.values(airports)[j],
                                    arrcode: lsArrCodes
                                }; ///list of arrival for particular departure

                                listOfRoutes.push(lsArrCodesForDep); ///list of routes for particular country
                            }
                        }

                        let countryRoute = {
                            country: Object.values(countries)[i],
                            routeList: listOfRoutes
                        };
                        listOfRoutes = [];
                        this.lsCountryRoute.push(countryRoute);
                    }
                    let startCountry = cloneData(this.lsCountryRoute[0]);
                    for (let index = 0; index < this.lsCountryRoute.length; index++) {
                        const countryObj = this.lsCountryRoute[index];
                        if(countryObj.country.countrycode==BaseConfiguration.defaultCountryValue){
                            this.lsCountryRoute[0]=countryObj;
                            this.lsCountryRoute[index]=startCountry;
                            break;
                        }

                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error while formatting routes",
                        err.toString(),
                        "getRoutesByCountryCode",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            ///to change class of city picker
            addCssClass() {
                //
                try {
                    if (BaseConfiguration.isDebug) console.log("addCssClass");

                    let countryTitleLIst = document.getElementsByClassName(
                        "multiselect__option--disabled"
                    );
                    setTimeout(() => {
                        for (let index = 0; index < countryTitleLIst.length; index++) {
                            const element = countryTitleLIst[index];
                            element.parentNode.classList.add("active");
                        }
                    },100);

                } catch (error) {
                    //ignore
                }
            },
            // clearAllFilter() {
            //   try {
            //     if (BaseConfiguration.isDebug) console.log("clearAllFilter");
            //     //let retValue;
            //     //   this.selectedTicketQue.selResId.id = DEFAULT_DROPDOWN_STATUS.ALL;
            //     //   this.selectedTicketQue.selPNR.pnr = DEFAULT_DROPDOWN_STATUS.ALL
            //     //   this.selectedTicketQue.selPassengerName.name = DEFAULT_DROPDOWN_STATUS.ALL
            //     //   this.selectedTicketQue.departure.dep = DEFAULT_DROPDOWN_STATUS.ALL
            //     //   this.selectedTicketQue.arrival.arr = DEFAULT_DROPDOWN_STATUS.ALL
            //     //   this.selectedTicketQue.journeyType.type = DEFAULT_DROPDOWN_STATUS.ALL
            //     //   this.selectedTicketQue.airline.air = DEFAULT_DROPDOWN_STATUS.ALL
            //     //   this.selectedTicketQue.userName.user = DEFAULT_DROPDOWN_STATUS.ALL
            //     //   this.selectedTicketQue.agentName.agent = DEFAULT_DROPDOWN_STATUS.ALL

            //     this.selectedTicketQue.selResId = "";
            //     this.selectedTicketQue.selPNR = "";
            //     this.selectedTicketQue.selPassengerName = "";
            //     this.selectedTicketQue.departure = "";
            //     this.selectedTicketQue.arrival = "";
            //     this.selectedTicketQue.journeyType = "";
            //     this.selectedTicketQue.airline = "";
            //     this.selectedTicketQue.userName = "";
            //     this.selectedTicketQue.agentName = "";
            //     this.fromDate = new Date();
            //     this.toDate = new Date();
            //     this.$refs.datePicker.checkIn = new Date();
            //     this.$refs.datePicker.checkOut = new Date();
            //     this.onChange();
            //   } catch (err) {
            //     let body = Logger.buildRequest(
            //       FILE_NAME.C_TICKETING_QUEUE,
            //       "error in clearAllFilter",
            //       err.toString(),
            //       "clearAllFilter",
            //       LOG_TYPE.ERROR
            //     );
            //     Logger.getResponse(body);
            //   }
            //   //return retValue;
            // },

            // onChange(pChange, isFromDate) {
            //   try {
            //     if (BaseConfiguration.isDebug) console.log("onChange");
            //     // let retValue;
            //     // this.fromDate = new Date();
            //     // this.toDate = new Date();

            //     if (pChange) {
            //       //   if (pChange.id) this.selectedTicketQue.selResId = pChange;
            //       //   if (pChange.pnr) this.selectedTicketQue.selPNR = pChange;
            //       //   if (pChange.name) this.selectedTicketQue.selPassengerName = pChange;
            //       //   if (pChange.dep) this.selectedTicketQue.departure = pChange;
            //       //   if (pChange.arr) this.selectedTicketQue.arrival = pChange;
            //       if (pChange.type) this.selectedTicketQue.journeyType = pChange;
            //       if (pChange.air) this.selectedTicketQue.airline = pChange;
            //       //   if (pChange.user) this.selectedTicketQue.userName = pChange;
            //       //   if (pChange.agent) this.selectedTicketQue.agentName = pChange;
            //       //   if(isFromDate == true) this.fromDate = formatDate(new Date(pChange),"DD-MMM-YYYY");
            //       //   if(isFromDate == true) this.toDate = formatDate(new Date(),"DD-MMM-YYYY");
            //       //   if(isFromDate == false) this.toDate = formatDate(new Date(pChange),"DD-MMM-YYYY");
            //     }

            //     let ticketQList = [];

            //     if (
            //       //   this.selectedTicketQue.selResId.id == DEFAULT_DROPDOWN_STATUS.ALL &&
            //       //   this.selectedTicketQue.selPNR.pnr == DEFAULT_DROPDOWN_STATUS.ALL &&
            //       //   this.selectedTicketQue.selPassengerName.name == DEFAULT_DROPDOWN_STATUS.ALL &&
            //       //   this.selectedTicketQue.departure.dep == DEFAULT_DROPDOWN_STATUS.ALL &&
            //       //   this.selectedTicketQue.arrival.arr == DEFAULT_DROPDOWN_STATUS.ALL &&
            //       //   this.selectedTicketQue.journeyType.type == DEFAULT_DROPDOWN_STATUS.ALL &&
            //       //   this.selectedTicketQue.airline.air == DEFAULT_DROPDOWN_STATUS.ALL &&
            //       //   this.selectedTicketQue.userName.user == DEFAULT_DROPDOWN_STATUS.ALL &&
            //       //   this.selectedTicketQue.agentName.agent == DEFAULT_DROPDOWN_STATUS.ALL &&
            //       this.selectedTicketQue.selResId == "" &&
            //       this.selectedTicketQue.selPNR == "" &&
            //       this.selectedTicketQue.selPassengerName == "" &&
            //       this.selectedTicketQue.departure == "" &&
            //       this.selectedTicketQue.arrival == "" &&
            //       //   (this.selectedTicketQue.journeyType? this.selectedTicketQue.journeyType.type == DEFAULT_DROPDOWN_STATUS.ALL : this.selectedTicketQue.journeyType == null) &&
            //       //   (this.selectedTicketQue.airline? this.selectedTicketQue.airline.air == DEFAULT_DROPDOWN_STATUS.ALL : this.selectedTicketQue.airline == null) &&
            //       this.selectedTicketQue.journeyType == "" &&
            //       this.selectedTicketQue.airline == "" &&
            //       this.selectedTicketQue.userName == "" &&
            //       this.selectedTicketQue.agentName == "" &&
            //       formatDate(this.fromDate, "DD-MMM-YYYY") ==
            //         formatDate(new Date(), "DD-MMM-YYYY") &&
            //       formatDate(this.toDate, "DD-MMM-YYYY") ==
            //         formatDate(new Date(), "DD-MMM-YYYY")
            //     ) {
            //       ticketQList = this.ticketingQueueResponse;
            //     } else {
            //       for (
            //         let index = 0;
            //         index < this.ticketingQueueResponse.length;
            //         index++
            //       ) {
            //         const ticket = this.ticketingQueueResponse[index];
            //         let resId = ticket.orderId ? ticket.orderId : null;
            //         let name = ticket.passengername ? ticket.passengername : null;
            //         let type = ticket.journeytype ? ticket.journeytype : null;
            //         let jType =
            //           type == this.journeyType.oneWay
            //             ? this.$t("ticketingQueue.oneWay")
            //             : type == this.journeyType.roundTrip
            //             ? this.$t("ticketingQueue.roundTrip")
            //             : type == this.journeyType.multiCity
            //             ? this.$t("ticketingQueue.multiCity")
            //             : null;
            //         let user = ticket.username ? ticket.username : null;
            //         let agent = ticket.agencyname ? ticket.agencyname : null;

            //         for (let index = 0; index < ticket.FlightDetails.length; index++) {
            //           const flight = ticket.FlightDetails[index];
            //           let pnr = flight.pnr ? flight.pnr : null;
            //           let dep = ticket.FlightDetails[0].departure
            //             ? ticket.FlightDetails[0].departure
            //             : null;
            //           let arr = ticket.FlightDetails[0].arrival
            //             ? ticket.FlightDetails[0].arrival
            //             : null;
            //           let air = flight.airline ? flight.airline : null;
            //           let depDate = ticket.FlightDetails[0].departuredate
            //             ? formatDate(
            //                 new Date(ticket.FlightDetails[0].departuredate),
            //                 "DD-MMM-YYYY"
            //               )
            //             : null;
            //           let arrDate = ticket.FlightDetails[0].returndate
            //             ? formatDate(
            //                 new Date(ticket.FlightDetails[0].returndate),
            //                 "DD-MMM-YYYY"
            //               )
            //             : null;

            //           if (
            //             // (this.selectedTicketQue.selResId.id == resId || this.selectedTicketQue.selResId.id == DEFAULT_DROPDOWN_STATUS.ALL) &&
            //             // (this.selectedTicketQue.selPNR.pnr == pnr || this.selectedTicketQue.selPNR.pnr == DEFAULT_DROPDOWN_STATUS.ALL) &&
            //             // (this.selectedTicketQue.selPassengerName.name == name || this.selectedTicketQue.selPassengerName.name == DEFAULT_DROPDOWN_STATUS.ALL) &&
            //             // (this.selectedTicketQue.departure.dep == dep || this.selectedTicketQue.departure.dep == DEFAULT_DROPDOWN_STATUS.ALL) &&
            //             // (this.selectedTicketQue.arrival.arr == arr || this.selectedTicketQue.arrival.arr == DEFAULT_DROPDOWN_STATUS.ALL) &&
            //             // (this.selectedTicketQue.journeyType.type == jType || this.selectedTicketQue.journeyType.type == DEFAULT_DROPDOWN_STATUS.ALL) &&
            //             // (this.selectedTicketQue.airline.air == air || this.selectedTicketQue.airline.air == DEFAULT_DROPDOWN_STATUS.ALL) &&
            //             // (this.selectedTicketQue.userName.user == user || this.selectedTicketQue.userName.user == DEFAULT_DROPDOWN_STATUS.ALL) &&
            //             // (this.selectedTicketQue.agentName.agent == agent || this.selectedTicketQue.agentName.agent == DEFAULT_DROPDOWN_STATUS.ALL) &&
            //             (this.selectedTicketQue.selResId == resId ||
            //               this.selectedTicketQue.selResId == "") &&
            //             (this.selectedTicketQue.selPNR == pnr ||
            //               this.selectedTicketQue.selPNR == "") &&
            //             (this.selectedTicketQue.selPassengerName == name ||
            //               this.selectedTicketQue.selPassengerName == "") &&
            //             (this.selectedTicketQue.departure == dep ||
            //               this.selectedTicketQue.departure == "") &&
            //             (this.selectedTicketQue.arrival == arr ||
            //               this.selectedTicketQue.arrival == "") &&
            //             // (this.selectedTicketQue.journeyType? (this.selectedTicketQue.journeyType.type == jType || this.selectedTicketQue.journeyType.type == DEFAULT_DROPDOWN_STATUS.ALL) : this.selectedTicketQue.journeyType == null) &&
            //             // (this.selectedTicketQue.airline? (this.selectedTicketQue.airline.air == air || this.selectedTicketQue.airline.air == DEFAULT_DROPDOWN_STATUS.ALL) : this.selectedTicketQue.airline == null) &&
            //             (this.selectedTicketQue.journeyType
            //               ? this.selectedTicketQue.journeyType.type == jType
            //               : this.selectedTicketQue.journeyType == "") &&
            //             (this.selectedTicketQue.airline
            //               ? this.selectedTicketQue.airline.air == air
            //               : this.selectedTicketQue.airline == "") &&
            //             (this.selectedTicketQue.userName == user ||
            //               this.selectedTicketQue.userName == "") &&
            //             (this.selectedTicketQue.agentName == agent ||
            //               this.selectedTicketQue.agentName == "") &&
            //             (formatDate(this.fromDate, "DD-MMM-YYYY") == depDate ||
            //               formatDate(this.fromDate, "DD-MMM-YYYY") ==
            //                 formatDate(new Date(), "DD-MMM-YYYY")) &&
            //             (formatDate(this.toDate, "DD-MMM-YYYY") == arrDate ||
            //               formatDate(this.toDate, "DD-MMM-YYYY") ==
            //                 formatDate(new Date(), "DD-MMM-YYYY"))
            //           ) {
            //             ticketQList.push(ticket);
            //           }
            //         }
            //       }
            //     }
            //     this.ticketingQueueList = ticketQList;
            //     this.ticketingQueueList = removeDuplicates(
            //       this.ticketingQueueList,
            //       "orderId"
            //     );
            //   } catch (err) {
            //     let body = Logger.buildRequest(
            //       FILE_NAME.C_TICKETING_QUEUE,
            //       "error in onChange",
            //       err.toString(),
            //       "onChange",
            //       LOG_TYPE.ERROR
            //     );
            //     Logger.getResponse(body);
            //   }
            //   //return retValue;
            // },

            // getTicketingQueueDetail(tcktQList) {
            //   try {
            //     if (BaseConfiguration.isDebug) console.log("getTicketingQueueDetail");
            //     //let retValue;
            //     if (tcktQList.length > 0) {
            //       for (let index = 0; index < tcktQList.length; index++) {
            //         const tckt = tcktQList[index];
            //         // if (tckt.orderId)
            //         //   this.ticketingQueFilterOption.resId.push({ id: tckt.orderId });
            //         // if (tckt.passengername)
            //         //   this.ticketingQueFilterOption.passengerName.push({
            //         //     name: tckt.passengername
            //         //   });
            //         //  this.ticketingQueFilterOption.journeyType.push({type: DEFAULT_DROPDOWN_STATUS.ALL});
            //         //  this.ticketingQueFilterOption.airline.push({ air : DEFAULT_DROPDOWN_STATUS.ALL});
            //         if (tckt.journeytype) {
            //           let jType =
            //             tckt.journeytype == this.journeyType.oneWay
            //               ? { type: this.$t("ticketingQueue.oneWay") }
            //               : tckt.journeytype == this.journeyType.roundTrip
            //               ? { type: this.$t("ticketingQueue.roundTrip") }
            //               : tckt.journeytype == this.journeyType.multiCity
            //               ? { type: this.$t("ticketingQueue.multiCity") }
            //               : null;
            //           this.ticketingQueFilterOption.journeyType.push(jType);
            //         }
            //         // if (tckt.username)
            //         //   this.ticketingQueFilterOption.userName.push({
            //         //     user: tckt.username
            //         //   });
            //         // if (tckt.agencyname)
            //         //   this.ticketingQueFilterOption.agentName.push({
            //         //     agent: tckt.agencyname
            //         //   });

            //         for (let index = 0; index < tckt.FlightDetails.length; index++) {
            //           const flight = tckt.FlightDetails[index];
            //           //   if (flight.pnr)
            //           //     this.ticketingQueFilterOption.pnr.push({ pnr: flight.pnr });
            //           //   if(flight.departure)
            //           //     this.ticketingQueFilterOption.departure.push({ dep : flight.departure});
            //           //   if(flight.arrival)
            //           //     this.ticketingQueFilterOption.arrival.push({ arr : flight.departure});
            //           if (flight.airline)
            //             this.ticketingQueFilterOption.airline.push({
            //               air: flight.airline
            //             });
            //         }
            //       }
            //     }
            //     // this.ticketingQueFilterOption.resId = removeDuplicates(
            //     //   this.ticketingQueFilterOption.resId,
            //     //   "id"
            //     // );
            //     // this.ticketingQueFilterOption.pnr = removeDuplicates(
            //     //   this.ticketingQueFilterOption.pnr,
            //     //   "pnr"
            //     // );
            //     // this.ticketingQueFilterOption.passengerName = removeDuplicates(
            //     //   this.ticketingQueFilterOption.passengerName,
            //     //   "name"
            //     // );
            //     // this.ticketingQueFilterOption.departure = removeDuplicates(
            //     //   this.ticketingQueFilterOption.departure,
            //     //   "dep"
            //     // );
            //     // this.ticketingQueFilterOption.arrival = removeDuplicates(
            //     //   this.ticketingQueFilterOption.arrival,
            //     //   "arr"
            //     // );
            //     this.ticketingQueFilterOption.journeyType = removeDuplicates(
            //       this.ticketingQueFilterOption.journeyType,
            //       "type"
            //     );
            //     this.ticketingQueFilterOption.airline = removeDuplicates(
            //       this.ticketingQueFilterOption.airline,
            //       "air"
            //     );
            //     // this.ticketingQueFilterOption.userName = removeDuplicates(
            //     //   this.ticketingQueFilterOption.userName,
            //     //   "user"
            //     // );
            //     // this.ticketingQueFilterOption.agentName = removeDuplicates(
            //     //   this.ticketingQueFilterOption.agentName,
            //     //   "agent"
            //     // );
            //   } catch (err) {
            //     let body = Logger.buildRequest(
            //       FILE_NAME.C_TICKETING_QUEUE,
            //       "error in getTicketingQueueDetail",
            //       err.toString(),
            //       "getTicketingQueueDetail",
            //       LOG_TYPE.ERROR
            //     );
            //     Logger.getResponse(body);
            //   }
            //   // return retValue;
            // }

            assignValuesFromStore() {
                try {
                    if(BaseConfiguration.isDebug) console.log("assignValuesFromStore");
                    if(this.isBooking){
                        if(this.GET_BOOKING_SEARCH_OBJ){

                            this.searchObj=this.GET_BOOKING_SEARCH_OBJ;
                            if(this.GET_BOOKING_ROUTE){
                                this.search=this.GET_BOOKING_ROUTE;

                            }
                        }else{
                            this.searchObj = this.filterObject;

                        }
                        if(this.GET_BOOK_TABLE_WATCH_LIST){
                            this.cTicketingTableWatchList=this.GET_BOOK_TABLE_WATCH_LIST;
                        }
                    }else{
                        if(this.GET_TICKETING_SEARCH_OBJ){
                            this.searchObj=this.GET_TICKETING_SEARCH_OBJ;
                            if(this.GET_TICKETING_ROUTE){
                                this.search=this.GET_TICKETING_ROUTE;

                            }

                        }else{
                            this.searchObj = this.filterObject;

                        }
                        if(this.GET_TQ_TABLE_WATCH_LIST){
                            this.cTicketingTableWatchList=this.GET_TQ_TABLE_WATCH_LIST;
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in assignValuesFromStore",
                        err.toString(),
                        "assignValuesFromStore",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
        },

        computed: {
///only for table items for sorting purpose(nested keys)
  tQComputedList () {
      let retValue=[];
    // return this.ticketingQueueList.map(item => {item,{ pnr: item.FlightDetails}})
     this.ticketingQueueList.forEach(item => {
            if (item && item.FlightDetails){
                item.pnr=[];
                item.flight_number=[];
                item.departuredate=[];
                item.ticketnumbers=[];
                item.FlightDetails
                  .map(flight => {
                    if (flight.pnr) 
                    {
                    item.pnr.push(flight.pnr.toString());
                    }
                     if (flight.flight_number) {
                    item.flight_number.push(flight.flight_number.toString());
                     }
                      if (flight.departuredate) {
                    item.departuredate.push(flight.departuredate);
                      }
                       if (flight.ticketnumbers) {
                    item.ticketnumbers.push(flight.ticketnumbers);
                    }
                  })


                  retValue.push(item)
            }
          });
          return retValue;

  },

// , { pnr: item.FlightDetails.forEach(flight => {return flight.pnr})}
            BOOKING_ORDER_TYPE()
            {
                return BOOKING_ORDER_TYPE
            },


               DATE_TIME_FORMAT()
          {
            return DATE_TIME_FORMAT
          },
            ...mapGetters("sDashBoard", {

                GET_NAV_BOOL: "GET_NAV_BOOL"
            }),
            ...mapGetters("sSysLogin", {
                ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
            }),
            ...mapGetters("sAgtLogin", {
                AGENT_SIGNIN_RES: "GET_SIGNIN_RES"
            }),
            ...mapGetters("cTicketingDetail", {
                GET_TICKETING_SEARCH_OBJ: "GET_FILTER_SEARCH_OBJ",
                GET_TICKETING_ROUTE:"GET_FILTER_ROUTE",
                GET_TICKETING_QUEUE_RES:"GET_TICKETING_QUEUE_RES",
                GET_TQ_TABLE_WATCH_LIST:"GET_TABLE_WATCH_LIST"


            }),
            ...mapGetters("cBookingDetail", {
                GET_BOOKING_SEARCH_OBJ: "GET_FILTER_SEARCH_OBJ",
                GET_BOOKING_ROUTE:"GET_FILTER_ROUTE",
                GET_BOOKING_LIST_RES:"GET_BOOKING_LIST_RES",
                GET_BOOK_TABLE_WATCH_LIST:"GET_TABLE_WATCH_LIST"

            }),

        },

        watch: {
            ticketingQueueResponse(val) {
                if (val) {
                    this.ticketingQueueList = cloneData(val);
                    this.jsonData = this.getJsonData(val);
                           this.isLoading=false;
                     this.isFiltersApplied=true;

                }
            }

        },
        beforeDestroy(){
         if(this.isBooking){
                        this.SET_BOOK_TABLE_WATCH_LIST(this.cTicketingTableWatchList);
                    }else{
                        this.SET_TQ_TABLE_WATCH_LIST(this.cTicketingTableWatchList);
                    }
        },
        // updated() {
        //         var table = document.getElementById("user-manage-table");
        //         if(table){
        //             console.log(table.scrollLeft);
        //         }
        // },
        async created() {
            // if (this.ticketingQueueResponse) {
                this.tickQueueFields=this.ticketingQueueField;
            this.ticketingQueueList = cloneData(this.ticketingQueueResponse);
            this.jsonData = this.getJsonData(this.ticketingQueueResponse);


            this.assignValuesFromStore();

            //  this.onSearch();

            // this.searchObj = this.filterObject;


            this.filterOption.user = await this.getAllUser();
            this.filterOption.user=OrderByList(this.filterOption.user,this.getPropToSortUsers,ORDER.ASC);


            this.routesResponse = await this.getRoutesResponse();
            if (this.routesResponse != null) {
                this.getRoutesByCountryCode();
            }

            if(this.GET_NAV_BOOL){
                this.onSearch();
            }


            // if (this.ticketingQueueResponse) {
            //   this.getTicketingQueueDetail(this.ticketingQueueResponse);
            //   // this.jsonData = this.getJsonData(this.ticketingQueueResponse);
            // }

       this.isLoading=false;
        }
    };

    /*var table = document.getElementById("user-manage-table");
    if(table)
    table.addEventListener("scroll", function (event) {
        /*var scroll = this.scrollY;
        console.log(scroll)
        console.log(table.scrollLeft);
    });*/
    
              

</script>
